import { RamosCodes } from '../models/ramosCodes.model';
import { SeguradorasBase } from '../models/seguradoras/factory/base.model';
import { CalcsGrid } from '../models/calculos/calcs-grid';
import { ViewValue } from '../models/view-value.model';
import { AplicacaoIdModel } from '../models/aplicacaoId.model';
import { SeguradoraPathProps } from '../models/seguradora-logo-path.model';
import { TipoCupom } from '../models/tipoCupom.model';
import { V } from '@angular/cdk/keycodes';

export class IntegracaoConstants {


  public static get motivos() { // Puxa a descricao da seguradora pelo nome.
    return {
      1: 'Cálculo com informações divergentes',
      2: 'Redirecionamento pela extensão',
      3: 'Outros',
      4: 'Sugestões'
    };
  }

  public static get cobsByRamoId(): any {
    const cobs = {};

    cobs[this.ramos.AUTO] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'modeloSelecionado',
        'tipoFranquia',
        'casco',
        'cascoTxt',
        'percComissao',
        'percDesconto',
        'isDanosMateriais',
        'isDanosMorais',
        'isDanosCorporais',
        'isAppMorte',
        'isAppInvalidez',
        'invalidezPermanente',
        'isBlindagemValor'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        tipoTxtLim: 0,
        isDanosMateriaisTxtRS: 1,
        isDanosCorporaisTxtRS: 2,
        assist24hsTxtLim: 3,
        carroReservaTxtLim: 4,
        vidrosTxtLim: 5,
        isDanosMoraisTxtRS: 6,
        isAppMorteTxtRS: 7,
        isAppInvalidezTxtRS: 8,
        isBlindagemValorTxtRS: 9
      }
    };
    cobs[this.ramos.VIDA] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'morteTxt',
        'invalidezPermanenteTxt',
        'doencasGravesTxt',
        'isDespesasMedicasHospitalaresTxt',
        'isInvalidezDoencaTxt',
        "valorDITTxt",
        "valorDoencasTxt",
        'funeralTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        morteTxtRS: 1,
        morteAcidentalTxtRS: 2,
        invalidezPermanenteTxtRS: 3,
        isDespesasMedicasHospitalaresTxtRS: 4,
        isInvalidezDoencaTxtRS: 5,
        valorDITTxtRS: 6,
        diariasDITTxt: 7,
        esportesRadicaisTxt: 8,
        valorDoencasTxtRS: 9,
        qtdDoencasGravesTxt: 10,
        funeralTxtCob: 11
      }
    };
    cobs[this.ramos.VIDA_GLOBAL] = {
      cobExclude: [
        // Adicionar as coberturas que não devem ser exibidas
        'morteTxt',
        'morteSocioTxt',
        'invalidezPermanenteTxt',
        'invalidezPermanenteSocioTxt',
        'isInvalidezDoencaTxt',
        'isInvalidezDoencaSocioTxt',
        'funeralTxt',
        'funeralSocioTxt',
      ],
      cobPriority: {
        // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        morteTxtRS: 1,
        morteSocioTxtRS: 2,
        morteAcidentalTxtRS: 3,
        morteAcidentalSocioTxtRS: 4,
        invalidezPermanenteTxtRS: 5,
        invalidezPermanenteSocioTxtRS: 6,
        isInvalidezDoencaTxtRS: 7,
        isInvalidezDoencaSocioTxtRS: 8,
        funeralTxtCob: 9,
        funeralSocioTxtCob: 10
      },
    };
    cobs[this.ramos.ACIDENTES_PESSOAIS] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'morteAcidentalTxt',
        'invalidezPermanenteTxt',
        "valorDITTxt",
        'funeralTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        morteAcidentalTxtRS: 1,
        invalidezPermanenteTxtRS: 2,
        valorDITTxtRS: 3,
        diariasDITTxt: 4,
        funeralTxtCob: 5
      }
    };
    cobs[this.ramos.VIAGEM] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'isDespesasMedicasHospitalaresTxt',
        'morteAcidentalTxt',
        'invalidezPermanenteTxt',
        'danosBagagemTxt',
        'funeralTxt',
        'cancelamentoTxt',
        'interrupcaoTxt',
        'extravioBagagemTxt',
        'trasladoCorpoTxt',
        'trasladoMedicoTxt',
        'regressoSanitarioTxt',
        'retornoSeguradoTxt',
        'retornoFamiliarTxt',
        'retornoAcompanhanteTxt',
        'retornoMenoresTxt',
        'acompanhanteHospitalizacaoTxt',
        'hospedagemAcompanhanteTxt',
        'acompanhamentoMenorTxt',
        'fisioterapiaTxt',
        'assistenciaFarmaceuticaTxt',
        'assistenciaJuridicaTxt',
        'pagamentoFiancaTxt',
        'prorrogacaoEstadaTxt',
        'atrasoBagagemTxt',
        'atrasoEmbarqueTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        isDespesasMedicasHospitalaresTxtRS: 1,
        morteAcidentalTxtRS: 2,
        invalidezPermanenteTxtRS: 3,
        danosBagagemTxtRS: 4,
        funeralTxtRS: 5,
        cancelamentoTxtRS: 6,
        interrupcaoTxtRS: 7,
        extravioBagagemTxtRS: 8,
        trasladoCorpoTxtRS: 9,
        trasladoMedicoTxtRS: 10,
        regressoSanitarioTxtRS: 11,
        retornoSeguradoTxtRS: 12,
        retornoFamiliarTxtRS: 13,
        retornoAcompanhanteTxtRS: 14,
        retornoMenoresTxtRS: 15,
        acompanhanteHospitalizacaoTxtRS: 16,
        hospedagemAcompanhanteTxtRS: 17,
        acompanhamentoMenorTxtRS: 18,
        fisioterapiaTxtRS: 19,
        assistenciaFarmaceuticaTxtRS: 20,
        assistenciaJuridicaTxtRS: 21,
        pagamentoFiancaTxtRS: 22,
        prorrogacaoEstadaTxtRS: 23,
        atrasoBagagemTxtRS: 24,
        atrasoEmbarqueTxtRS: 25
      }
    };
    cobs[this.ramos.RESIDENCIAL] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'isDanosIncendioRaioExplosao',
        'isDanosIncendioRaioExplosaoTxt',
        'isDanosRoubo',
        'isDanosRouboTxt',
        'isDanosAlagamento',
        'isDanosAlagamentoTxt',
        'isDanosEletricos',
        'isDanosEletricosTxt',
        'isDanosAluguel',
        'isDanosAluguelTxt',
        'isDanosDesmoronamento',
        'isDanosDesmoronamentoTxt',
        'isDanosVendaval',
        'isDanosVendavalTxt',
        'isDanosImpactoVeiculo',
        'isDanosImpactoVeiculoTxt',
        'isDanosVidros',
        'isDanosVidrosTxt',
        'assist24hsTxt',
        'isDanosImpactoVeiculoVendaval',
        'isDanosImpactoVeiculoVendavalTxt',
        'isDanosRegistrosDocumentosTxt',
        'isDanosRegistrosDocumentos',
        'isDanosEquipamentosPortateisForaTxt',
        'isDanosEquipamentosPortateisFora',
        'isDanosEquipamentosEletronicosTxt',
        'isDanosEquipamentosEletronicos',
        'isDanosVazamentoTanquesTubulacoes',
        'isDanosVazamentoTanquesTubulacoesTxt',
        'isDanosMorais',
        'isDanosMoraisTxt',
        'tumultoGreveLockOut',
        'tumultoGreveLockOutTxt',
        'placasSolares',
        'placasSolaresTxt',
        'bike',
        'bikeTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        isDanosIncendioRaioExplosaoTxtRS: 1,
        isDanosRouboTxtRS: 2,
        isDanosAlagamentoTxtRS: 3,
        isDanosEletricosTxtRS: 4,
        isDanosAluguelTxtRS: 5,
        isDanosDesmoronamentoTxtRS: 6,
        isDanosVendavalTxtRS: 7,
        isDanosImpactoVeiculoTxtRS: 8,
        isDanosVidrosTxtRS: 11,
        assist24hsTxtMod: 10,
        isDanosImpactoVeiculoVendavalTxtRS: 9,
        isDanosVazamentoTanquesTubulacoesTxtRS: 12,
        isDanosRegistrosDocumentosTxtRS: 15,
        isDanosEquipamentosPortateisForaTxtRS: 13,
        isDanosEquipamentosEletronicosTxtRS: 14,
        isDanosMoraisTxtRS: 16,
        tumultoGreveLockOutTxtRS: 17,
        placasSolaresTxtRS: 18,
        bikeTxtRS: 19
      }
    };
    cobs[this.ramos.EMPRESARIAL] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'isDanosIncendioRaioExplosao',
        'isDanosIncendioRaioExplosaoTxt',
        'isDanosRoubo',
        'isDanosRouboTxt',
        'isDanosEletricos',
        'isDanosEletricosTxt',
        'isDanosContaminacaoDeterioracaoTxt',
        'isDanosAluguel',
        'isDanosAluguelTxt',
        'isDanosImpactoVeiculo',
        'isDanosImpactoVeiculoTxt',
        'isDanosVidros',
        'isDanosVidrosTxt',
        'assist24hsTxt',
        'equipamentosTxt',
        'isEmpregadorTxt',
        'isDanosMoraisTxt',
        'anunciosLuminososTxt',
        'recomposicaoDocumentosTxt',
        'rouboFurtoDeValoresTxt',
        'tumultoGreveLockOutTxt',
        'lucroCessanteTxt',
        'isDanosDesmoronamentoTxt',
        'chuveiroSprinklerTxt',
        'fidelidadeTxt',
        'placasSolaresTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        isDanosIncendioRaioExplosaoTxtRS: 1,
        isDanosRouboBensTxtRS: 2,
        rouboFurtoDeValoresTxtRS: 3,
        isDanosEletricosTxtRS: 4,
        isDanosAluguelTxtRS: 5,
        isDanosImpactoVeiculoTxtRS: 6,
        isDanosVidrosTxtRS: 7,
        assistxtMod: 8,
        equipamentosTxtRS: 9,
        isDanosVazamentoTxtRS: 10,
        isDanosDespesasFixasTxtRS: 11,
        responsabilidadeCivilOperacoesTxtRS: 12,
        isEmpregadorTxtRS: 13,
        isDanosMoraisTxtRS: 14,
        anunciosLuminososTxtRS: 15,
        recomposicaoDocumentosTxtRS: 16,
        tumultoGreveLockOutTxtRS: 17,
        lucroCessanteTxtRS: 18,
        isGuardaVeiculoValorTxtRS: 19,
        isDanosVendavalTxtRS: 20,
        isDanosDesmoronamentoTxtRS: 21,
        chuveiroSprinklerTxtRS: 22,
        fidelidadeTxtRS: 23,
        placasSolaresTxtRS: 24,
        isDanosAlagamentoTxtRS: 25
      }
    };
    cobs[this.ramos.CONDOMINIO] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'isDanosIncendioRaioExplosao',
        'isDanosIncendioRaioExplosaoTxt',
        'isDanosRoubo',
        'isDanosRouboTxt',
        'isDanosAlagamento',
        'isDanosAlagamentoTxt',
        'isDanosEletricos',
        'isDanosEletricosTxt',
        'isDanosAluguel',
        'isDanosAluguelTxt',
        'isDanosDesmoronamento',
        'isDanosDesmoronamentoTxt',
        'isDanosImpactoVeiculo',
        'isDanosImpactoVeiculoTxt',
        'isDanosVendaval',
        'isDanosVendavalTxt',
        'isDanosVidros',
        'isDanosVidrosTxt',
        'assist24hsTxt',
        'isDanosIncendioRaioExplosaoCond',
        'isDanosIncendioRaioExplosaoCondTxt',
        'isValorCondominio',
        'isValorCondominioTxt',
        'isValorSindico',
        'isValorSindicoTxt',
        'anunciosLuminosos',
        'anunciosLuminososTxt',
        'tumultoGreveLockOut',
        'tumultoGreveLockOutTxt',
        'isDanosAlagamento',
        'isDanosAlagamentoTxt',
        'isDanosDespesasFixas',
        'isDanosDespesasFixasTxt',
        'equipamentos',
        'equipamentosTxt',
        'isEmpregador',
        'isEmpregadorTxt',
        'isVGFuncionarios',
        'isVGFuncionariosTxt',
        'garagista',
        'garagistaTxt',
        'garagistaExclusiva',
        'garagistaExclusivaTxt',
        'chuveiroSprinkler',
        'chuveiroSprinklerTxt',
        'placasSolares',
        'placasSolaresTxt',
        'isDanosPortoes',
        'isDanosPortoesTxt',
        'isDanosMorais',
        'isDanosMoraisTxt',
        'isDanosVazamentoTanquesTubulacoes',
        'isDanosVazamentoTanquesTubulacoesTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        isDanosIncendioRaioExplosaoTxtRS: 1,
        isDanosIncendioRaioExplosaoCondTxtRS: 2,
        isValorCondominioTxtRS: 3,
        isValorSindicoTxtRS: 4,
        isDanosRouboTxtRS: 5,
        isDanosEletricosTxtRS: 6,
        isDanosAluguelTxtRS: 7,
        isDanosDesmoronamentoTxtRS: 8,
        isDanosImpactoVeiculoTxtRS: 9,
        isDanosVendavalTxtRS: 10,
        isDanosPortoesTxtRS: 11,
        isDanosMoraisTxtRS: 12,
        isDanosVidrosTxtRS: 13,
        isDanosVazamentoTanquesTubulacoesTxtRS: 14,
        assist24hsTxtMod: 15,
        anunciosLuminososTxtRS: 16,
        tumultoGreveLockOutTxtRS: 17,
        isDanosAlagamentoTxtRS: 18,
        isDanosDespesasFixasTxtRS: 19,
        equipamentosTxtRS: 20,
        isEmpregadorTxtRS: 21,
        isVGFuncionariosTxtRS: 22,
        garagistaTxtRS: 23,
        garagistaExclusivaTxtRS: 24,
        chuveiroSprinklerTxtRS: 25,
        placasSolaresTxtRS: 26
      }
    };
    cobs[this.ramos.BIKE] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'isDanosTxt',
        'isDanosRouboTxt',
        'responsabilidadeCivilTxt',
        'assist24hsTxt',
        'isDanosEletricosTxt',
        'isApIndividualTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        isDanosTxtRS: 1,
        isDanosRouboTxtRS: 2,
        responsabilidadeCivilTxtRS: 3,
        assistxtMod: 4,
        isDanosEletricosTxtRS: 5,
        isApIndividualTxtRS: 6,
      }
    };
    cobs[this.ramos.ALUGUEL] = {
      cobExclude: [ // Adicionar as coberturas que não devem ser exibidas
        'aluguelTxt',
        'iptuTxt',
        'aguaTxt',
        'luzTxt',
        'assist24hsTxt',
        'gasTxt',
        'condominioTxt'
      ],
      cobPriority: { // É possível rever esta logica depois, fiz desta maneira pois é a mais facil, rapida e intuitiva pro momento
        aluguelTxtRS: 1,
        iptuTxtRS: 2,
        aguaTxtRS: 3,
        luzTxtRS: 4,
        gasTxtRS: 5,
        condominioTxtRS: 6,
        assistxtMod: 7,
        danoImovelTxt: 8,
        pinturaInternaTxt: 9,
        pinturaExternaTxt: 10,
        multaContratualTxt: 11
      }
    };
    return cobs;

  }

  public static get franquiasByRamoId(): any {
    const franquias = {};

    franquias[this.ramos.BIKE] = {
      franquiasPriority: {
        isDanosTxt: 1,
        isDanosRouboTxt: 2,
        responsabilidadeCivilTxt: 3,
        isDanosEletricosTxt: 4,
        isApIndividualTxt: 5
      }
    };
    return franquias;
  }

  public static get tipoPagamento(): any {
    return {
      1: 'credito',
      2: 'debito',
      3: 'boleto',
      5: 'cartaoEspecialSeguradora'
    };
  }

  public static get tipoPagamentoTxt(): any {

    return {
      1: 'Cartão de Crédito',
      2: 'Débito',
      3: 'Boleto',
    };

  }

  public static get coberturas(): any {

    return {
      tipoTxtLim: 'Tipo',
      tipoFranquia: 'Tipo Franquia',
      isDanosMateriais: 'Danos Materiais',
      isDanosMateriaisTxt: 'Danos Materiais',
      isDanosMateriaisTxtRS: 'Danos Materiais',
      isDanosCorporais: 'Danos Corporais',
      isDanosCorporaisTxt: 'Danos Corporais',
      isDanosCorporaisTxtRS: 'Danos Corporais',
      isDanosMorais: 'Danos Morais',
      isDanosMoraisTxt: 'Danos Morais',
      isDanosMoraisTxtRS: 'Danos Morais',
      isAppMorte: 'Morte',
      isAppMorteTxt: 'Morte',
      isAppMorteTxtRS: 'Morte',
      isAppInvalidez: 'Invalidez',
      isAppInvalidezTxt: 'Invalidez',
      isAppInvalidezTxtRS: 'Invalidez',
      isBlindagemValor: 'Blindagem',
      isBlindagemValorTxt: 'Blindagem',
      isBlindagemValorTxtRS: 'Blindagem',
      carroReserva: 'Carro Reserva',
      carroReservaTxtLim: 'Carro Reserva',
      assist24hs: '24 Horas',
      assist24hsTxtLim: '24 Horas',
      vidrosTxtLim: 'Vidros',
      invalidezPermanenteTxt: 'Invalidez perm. (IPA)',
      invalidezPermanenteTxtRS: 'Invalidez perm. (IPA)',
      invalidezPermanenteSocioTxt: 'Invalidez perm. (IPA) - Sócio',
      invalidezPermanenteSocioTxtRS: 'Invalidez perm. (IPA) - Sócio',
      morteTxt: 'Morte',
      morteTxtRS: 'Morte',
      morteAcidentalTxt: 'Morte Acidental',
      morteAcidentalTxtRS: 'Morte Acidental',
      morteAcidentalSocioTxt: 'Morte Acidental - Sócio',
      morteAcidentalSocioTxtRS: 'Morte Acidental - Sócio',
      praticaEsporteRadicalTxtRS: 'Pratica esportes radicais',
      isDespesasMedicasHospitalaresTxt: 'Diária de Inter. Hosp. (DIH)',
      isDespesasMedicasHospitalaresTxtRS: 'Diária de Inter. Hosp. (DIH)',
      isInvalidezDoencaTxt: 'Invalidez doença (IFPD)',
      isInvalidezDoencaTxtRS: 'Invalidez doença (IFPD)',
      isInvalidezDoencaSocioTxt: 'Invalidez doença (IFPD) - Sócio',
      isInvalidezDoencaSocioTxtRS: 'Invalidez doença (IFPD) - Sócio',
      qtdDoencasGravesTxt: 'Qtd. doenças graves',
      valorDoencasTxtRS: 'Doenças graves',
      diariasDITTxt: 'Qtd. diárias (DIT)',
      esportesRadicaisTxt: 'Esporte radical',
      valorDITTxtRS: 'Diária de Incap. Temp. (DIT)',
      funeralTxt: 'Funeral',
      funeralTxtCob: 'Funeral',
      funeralTxtRS: 'Funeral',
      funeralSocioTxt: 'Funeral - Sócio',
      funeralSocioTxtCob: 'Funeral - Sócio',
      isDanosAlagamento: 'Alagamento',
      isDanosAlagamentoTxt: 'Alagamento',
      isDanosAlagamentoTxtRS: 'Alagamento',
      isDanosIncendioRaioExplosao: 'Incêndio',
      isDanosIncendioRaioExplosaoTxt: 'Incêndio',
      isDanosIncendioRaioExplosaoTxtRS: 'Incêndio',
      isDanosDesmoronamentoTxt: 'Desmoronamento',
      isDanosDesmoronamentoTxtRS: 'Desmoronamento',
      isDanosVazamentoTanquesTubulacoesTxt: "Vazamento Tanques/Tubulações",
      isDanosVazamentoTanquesTubulacoesTxtRS: "Vazamento Tanques/Tubulações",
      isDanosVazamentoTxtRS: "Vazamento",
      isDanosAluguelTxt: 'Danos aluguel',
      isDanosAluguelTxtRS: 'Danos aluguel',
      isDanosEletricosTxt: 'Danos elétricos',
      isDanosEletricosTxtRS: 'Danos elétricos',
      isDanosVendavalTxt: 'Vendaval',
      isDanosVendavalTxtRS: 'Vendaval',
      isDanosImpactoVeiculoTxt: 'Impacto veículos',
      isDanosImpactoVeiculoTxtRS: 'Impacto veículos',
      isDanosImpactoVeiculoVendavalTxt: 'Imp. Veíc./Vendaval',
      isDanosImpactoVeiculoVendavalTxtRS: 'Imp. Veíc./Vendaval',
      isDanosRegistrosDocumentos: 'Recomp. Documentos',
      isDanosRegistrosDocumentosTxt: 'Recomp. Documentos',
      isDanosRegistrosDocumentosTxtRS: 'Recomp. Documentos',
      isDanosEquipamentosPortateisFora: 'Equip. Portáteis',
      isDanosEquipamentosPortateisForaTxt: 'Equip. Portáteis',
      isDanosEquipamentosPortateisForaTxtRS: 'Equip. Portáteis',
      isDanosDespesasFixasTxtRS: 'Despesas Fixas',
      isDanosEquipamentosEletronicosTxtRS: 'Equip. Eletrônicos',
      responsabilidadeCivilTxtRS: 'Resp. Civil',
      responsabilidadeCivilOperacoesTxtRS: 'RC Operações',
      isDanosRouboTxt: 'Roubo',
      isDanosRouboTxtRS: 'Roubo',
      isDanosTxt: 'Danos',
      isDanosTxtRS: 'Danos',
      isApIndividualTxt: 'AP Individual',
      isApIndividualTxtRS: 'AP Individual',
      isDanosRouboBensTxtRS: 'Roubo de Bens',
      isDanosVidrosTxt: 'Vidros',
      isDanosVidrosTxtRS: 'Vidros',
      assist24hsTxt: 'Assist. 24h ',
      assist24hsTxtMod: 'Assist. 24h ',
      assistxtMod: 'Assistência',
      isDanosEquipamentosEletronicos: 'Equip. Eletrônicos',
      isDanosVazamentoTanquesTubulacoes: 'Vazamento Tanques',
      equipamentosEstacionariosTxt: 'Equip. Estacionários',
      equipamentosEstacionariosTxtRS: 'Equip. Estacionários',
      isEmpregadorTxt: 'RC Empregador',
      isEmpregadorTxtRS: 'RC Empregador',
      isDanosIncendioRaioExplosaoCondTxt: 'Incêndio (condôminos)',
      isDanosIncendioRaioExplosaoCondTxtRS: 'Incêndio (condôminos)',
      isValorCondominioTxt: 'RC Condomínio',
      isValorCondominioTxtRS: 'RC Condomínio',
      isValorSindicoTxt: 'RC Síndico',
      isValorSindicoTxtRS: 'RC Síndico',
      isDanosPortoesTxt: 'Portões',
      isDanosPortoesTxtRS: 'Portões',
      isVGFuncionariosTxt: 'VG Funcionários',
      isVGFuncionariosTxtRS: 'VG Funcionários',
      garagistaTxt: 'RC Garagista (Compreensiva)',
      garagistaTxtRS: 'RC Garagista (Compreensiva)',
      garagistaExclusivaTxt: 'RC Garagista (Exclusiva)',
      garagistaExclusivaTxtRS: 'RC Garagista (Exclusiva)',
      chuveiroSprinklerTxt: 'Chuveiro / Sprinkler',
      chuveiroSprinklerTxtRS: 'Chuveiro / Sprinkler',
      placasSolaresTxt: 'Placas Solares',
      placasSolaresTxtRS: 'Placas Solares',
      bikeTxt: 'Bike',
      bikeTxtRS: 'Bike',
      anunciosLuminososTxt: 'Anúncios Luminosos',
      anunciosLuminososTxtRS: 'Anúncios Luminosos',
      equipamentosMoveisTxt: 'Equip. Móveis',
      equipamentosMoveisTxtRS: 'Equip. Móveis',
      equipamentosTxt: 'Equipamentos',
      equipamentosTxtRS: 'Equipamentos',
      recomposicaoDocumentosTxt: 'Recomp. de Doc.',
      recomposicaoDocumentosTxtRS: 'Recomp. de Doc.',
      fidelidadeTxt: 'Fidelidade',
      fidelidadeTxtRS: 'Fidelidade',
      rouboFurtoDeValoresTxt: 'Roubo de Valores',
      rouboFurtoDeValoresTxtRS: 'Roubo de Valores',
      tumultoGreveLockOutTxt: 'Tumultos, Greves e Lock-out',
      tumultoGreveLockOutTxtRS: 'Tumultos, Greves e Lock-out',
      lucroCessanteTxt: 'Lucros Cessantes',
      lucroCessanteTxtRS: 'Lucros Cessantes',
      isGuardaVeiculoValorTxtRS: 'RC Garagista',
      danosBagagemTxtRS: 'Danos de Bagagem',
      cancelamentoTxtRS: 'Cancelamento de Viagem',
      interrupcaoTxtRS: 'Interrupção de Viagem',
      extravioBagagemTxtRS: 'Extravio de Bagagem',
      trasladoCorpoTxtRS: 'Traslado de Corpo',
      trasladoMedicoTxtRS: 'Traslado Médico',
      regressoSanitarioTxtRS: 'Regresso Sanitário',
      retornoSeguradoTxtRS: 'Retorno do Segurado',
      retornoFamiliarTxtRS: 'Retorno da Família',
      retornoAcompanhanteTxtRS: 'Retorno de Acompanhante',
      retornoMenoresTxtRS: 'Retorno de Menores',
      acompanhanteHospitalizacaoTxtRS: 'Acompanhante Hospitalização',
      hospedagemAcompanhanteTxtRS: 'Hospedagem de Acompanhante',
      acompanhamentoMenorTxtRS: 'Acompanhamento de Menor',
      fisioterapiaTxtRS: 'Fisioterapia',
      assistenciaFarmaceuticaTxtRS: 'Despesas Farmacêuticas',
      assistenciaJuridicaTxtRS: 'Despesas Jurídicas',
      pagamentoFiancaTxtRS: 'Pagamento de Fiança',
      prorrogacaoEstadaTxtRS: 'Prorrogação de Estada',
      atrasoBagagemTxtRS: 'Atraso de Bagagem',
      atrasoEmbarqueTxtRS: 'Atraso de Embarque',
      aluguelTxtRS: 'Aluguel',
      iptuTxtRS: 'IPTU',
      aguaTxtRS: 'Água',
      luzTxtRS: 'Luz',
      gasTxtRS: 'Gás',
      condominioTxtRS: 'Condomínio',
      danoImovelTxt: 'Danos ao Imóvel',
      pinturaInternaTxt: 'Pintura Interna',
      pinturaExternaTxt: 'Pintura Externa',
      multaContratualTxt: 'Multa Contratual'
    };

  }

  public static get franquias(): any {
    return {
      isDanosTxt: 'Franquia Danos',
      isDanosRouboTxt: 'Franquia Roubo',
      isDanosEletricosTxt: 'Franquia Danos elétricos',
      responsabilidadeCivilTxt: 'Franquia Resp. Civil',
      isApIndividualTxt: 'Franquia AP Individual',
    }
  }

  public static get formsTitle() {
    return {
      v: 'Automóvel',
      c: 'Caminhão',
      m: 'Motocicleta'
    };
  }

  public static get calcsGrid(): CalcsGrid {

    return {
      main: {
        id: 1,
        description: {
          desktop: 'PRODUTOS PRINCIPAIS',
          mobile: 'PRINCIPAIS'
        }
      },
      alternatives: {
        id: 2,
        description: {
          desktop: 'PRODUTOS ALTERNATIVOS',
          mobile: 'ALTERNATIVOS'
        }
      },
      all: {
        id: 3,
        description: {
          desktop: 'TODOS',
          mobile: 'TODOS'
        }
      },
      porAssinatura: {
        id: 4,
        description: {
          desktop: 'PRODUTOS POR ASSINATURA',
          mobile: 'POR ASSINATURA'
        }
      }
    };

  }

  public static get seguradoras(): SeguradorasBase {
    return {
      BRADESCO: {
        id: 1,
        name: 'Bradesco',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'bradescoCodCorretor',
          'bradescoSucursal',
          'bradescoCodUsuario',
          'bradescoInspetoria',
          'bradescoContrato'
        ]
      },
      LIBERTY: {
        id: 2,
        name: 'Liberty WS',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      MAPFRE: {
        id: 3,
        name: 'Mapfre',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'mapfreCodVc',
          'mapfreCodInt',
          'mapfreSelCompanhia',
          'mapfreTpUsuario',
          'mapfreGrupoAfinidade'
        ]
      },
      HDI: {
        id: 4,
        name: 'HDI',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'hdiCodigoCorretor',
          'hdiCodigoProdutor',
          'hdiSucursal',
          'hdiEmpresa',
        ]
      },
      ALLIANZ: {
        id: 5,
        name: 'Allianz',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'allianzSucursalSelecionada'
        ]
      },
      SOMPO: {
        id: 6,
        name: 'Sompo',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'sompoCodigoCorretor'
        ]
      },
      ZURICH: {
        id: 7,
        name: 'Zurich',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      PORTO_SEGURO: {
        id: 8,
        name: 'Porto Seguro',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'portoSusep'
        ]
      },
      ITAU: {
        id: 9,
        name: 'Itaú',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      AZUL: {
        id: 10,
        name: 'Azul',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      TOKIO: {
        id: 11,
        name: 'Tokio',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'tokioCodigo',
          'tokioAgenciaFuncional',
          'tokioContaCorrente',
          'tokioMatricula'
        ]
      },
      LIBERTY_SITE: {
        id: 12,
        name: 'Liberty',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'libertyCodigoCorretor',
          'libertyCodigoFilial',
          'libertyCpfCnpj'
        ]
      },
      MITSUI: {
        id: 13,
        name: 'Mitsui',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'mitsuiCodigoCorretor',
          'mitsuiFilialNome'
        ]
      },
      GENERALI: {
        id: 14,
        name: 'Generali',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'generaliCodigo',
          'generaliSucursalSelecionada'
        ]
      },
      ITAU_PORTAL: {
        id: 15,
        name: 'Itaú',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      SOMPO_WS: {
        id: 16,
        name: 'Sompo WS',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      SULAMERICA: {
        id: 17,
        name: 'Sul América',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'sulAmericaEstrVenda',
          'sulAmericaEstrApoio',
          'sulAmericaAcaoApoio',
          'sulAmericaSucursal',
          'sulAmericaConvenio'
        ]
      },
      ALFA: {
        id: 18,
        name: 'Alfa',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      SANCOR: {
        id: 19,
        name: 'Sancor',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      SUHAI: {
        id: 20,
        name: 'Suhai',
        isCalcAutoAlternative: true,
        particularAttributes: []
      },
      TOKIO_AUTO_POPULAR: {
        id: 21,
        name: 'Tokio Auto Popular',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      ALIRO: {
        id: 22,
        name: 'Aliro',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'libertyCodigoCorretor',
          'libertyCodigoFilial',
          'libertyCpfCnpj'
        ]
      },
      ALLIANZ_PACOTE_ECONOMICO: {
        id: 23,
        name: 'Allianz Pacote Econômico',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      SURA: {
        id: 24,
        name: 'Sura',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      ICATU: {
        id: 25,
        name: 'Icatu',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      ITURAN: {
        id: 26,
        name: 'Ituran',
        isCalcAutoAlternative: true,
        particularAttributes: []
      },
      POTTENCIAL: {
        id: 27,
        name: 'Pottencial',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      SUICA: {
        id: 28,
        name: 'Suiça',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      GENTE: {
        id: 29,
        name: 'Gente',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      CHUBB: {
        id: 32,
        name: 'CHUBB',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      METLIFE: {
        id: 34,
        name: 'METLIFE',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      EZZE: {
        id: 43,
        name: 'Ezze',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      CAPEMISA:  {
        id: 39,
        name: 'CAPEMISA',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      CENTAURO: {
        id: 40,
        name: 'CENTAURO',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      AKAD: {
        id: 41,
        name: 'Akad',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      BERKLEY: {
        id: 42,
        name: 'Berkley',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },      
      AZUL_ASSINATURA: {
        id: 45,
        name: 'Azul por Assinatura',
        isCalcAutoAlternative: false,
        isCalcPorAssinatura: true,
        particularAttributes: [
          'portoSusep'
        ]
      },
      DARWIN: {
        id: 46,
        name: 'Darwin',
        isCalcAutoAlternative: false,
        isCalcPorAssinatura: true,
        particularAttributes: []
      },
      JUSTOS: {
        id: 47,
        name: 'Justos',
        isCalcAutoAlternative: false,
        isCalcPorAssinatura: true,
        particularAttributes: []
      },
      BP: {
        id: 48,
        name: 'BP Seguradora',
        isCalcAutoAlternative: false,
        particularAttributes: []
      },
      PIER: {
        id: 50,
        name: 'Pier',
        isCalcAutoAlternative: false,
        particularAttributes: [
          'code',
          'secondCode',
          'thirdCode'
        ]
      },
      SEG_TESTE: {
        id: 901,
        name: 'Seguradora de teste',
        isCalcAutoAlternative: false,
        particularAttributes: []
      }
    };
  }

  public static get stepsId(): any {
    return {
      resultados: 0,
      formulario: 1,
      simuladorComissoes: 2,
      enviarCalculo: 3,
      coberturas: 4,
      ajustePorSeguradora: 5
    };
  }

  public static get sexoTxt(): any {

    return {
      M: 'Masculino',
      F: 'Feminino'
    };

  }

  public static get tempoHabilitacaoTxt(): any {

    return {
      0: 'Recem habilitado',
      1: 'Até 1 ano',
      2: 'Até 2 anos',
      3: 'Até 3 anos',
      4: 'Até 4 anos',
      5: 'Até 5 anos',
      6: 'Até 6 anos',
      7: 'Até 7 anos',
      8: 'Até 8 anos',
      9: 'Até 9 anos',
      10: 'Até 10 anos',
      11: 'Mais de 10 anos',

    };

  }

  public static get profissoesTxt(): any { // UTILIZADO NO VIDA

    return {
      0: 'ADVOGADO (DIREITO PENAL / CRIMINALISTA)',
      1: 'ADVOGADO (EXCETO ADVOGADO DO DIREITO PENAL / CRIMINALISTA)',
      2: 'ALFAIATE',
      3: 'ANTROPÓLOGO',
      4: 'APOSENTADO POR INVALIDEZ (EXCETO FUNCIONÁRIO PÚBLICO)',
      5: 'APOSENTADO POR TEMPO DE SERVICO (EXCETO FUNCIONÁRIO PÚBLICO)',
      6: 'APOSENTADO POR INVALIDEZ (FUNCIONARIO PUBLICO)',
      7: 'APOSENTADO POR TEMPO DE SERVICO (FUNCIONARIO PUBLICO)',
      8: 'ARQUEÓLOGO',
      9: 'ARQUITETO',
      10: 'ASTRÓLOGO',
      11: 'ASTRÔNOMO',
      12: 'ATENDENTE OU RECEPCIONISTA',
      13: 'ATLETA PROFISSIONAL (OUTRAS MODALIDADES)',
      14: 'ATLETA PROFISSIONAL DE FUTEBOL',
      15: 'ATLETA PROFISSIONAL DE GOLFE',
      16: 'ATLETA PROFISSIONAL DE HOQUEI',
      17: 'ATLETA PROFISSIONAL DE LUTA',
      18: 'ATLETA PROFISSIONAL DE RUGBI',
      19: 'ATLETA PROFISSIONAL DE TENIS',
      20: 'ATLETA PROFISSIONAL DE VOLEI',
      21: 'ATOR',
      22: 'AUXILIAR ADMINISTRATIVO',
      23: 'AUXILIAR OU TÉCNICO DE ENFERMAGEM',
      24: 'BARBEIRO',
      25: 'BARMAN',
      26: 'BIBLIOTECÁRIO',
      27: 'BIOMÉDICO',
      28: 'BIÓLOGO',
      29: 'BOMBEIRO MILITAR (SOLDADO)',
      30: 'BOMBEIRO MILITAR (CABO)',
      31: 'BOMBEIRO MILITAR (SARGENTO)',
      32: 'BOMBEIRO MILITAR (SUBTENENTE)',
      33: 'BOMBEIRO MILITAR (TENENTE)',
      34: 'BOMBEIRO MILITAR (CAPITAO)',
      35: 'BOMBEIRO MILITAR (MAJOR)',
      36: 'BOMBEIRO MILITAR (TENENTE-CORONEL)',
      37: 'BOMBEIRO MILITAR (CORONEL)',
      38: 'CABELEIREIRO',
      39: 'CAMAREIRO',
      40: 'CARTEIRO',
      41: 'CHAVEIRO',
      42: 'CHEFE DE COZINHA',
      43: 'COMERCIANTE',
      44: 'CONTADOR, TÁCNICO OU ANALISTA EM CONTABILIDADE',
      45: 'COREÓGRAFO',
      46: 'CORRETOR DE IMÓVEIS',
      47: 'CORRETOR DE SEGUROS',
      48: 'COSTUREIRA OU ALFAIATE',
      49: 'COZINHEIRO OU AUXILIAR DE COZINHA',
      50: 'DANÇARINO OU BAILARINO',
      51: 'DECORADOR',
      52: 'DENTISTA',
      53: 'DEPUTADO',
      54: 'DESENHISTA',
      55: 'DIGITADOR',
      56: 'ECONOMISTA',
      57: 'ELETRICISTA DE INSTALAÇÕES E MANUTENÇÃO',
      58: 'EMPREGADO DOMÉSTICO',
      59: 'EMPRESÁRIO / DIRETOR GERAL DE EMPRESA',
      60: 'ENCANADOR',
      61: 'ENFERMEIRO PSIQUIATRICO ',
      62: 'ENFERMEIRO - EXCETO ENFERMEIRO PSIQUIATRICO ',
      63: 'ENGENHEIRO CIVIL E AFINS. ',
      64: 'ENGENHEIRO DE MINAS ',
      65: 'ENGENHEIRO DE VOO ',
      66: 'ENGENHEIRO ELETRICISTA ELETRONICO E AFINS ',
      67: 'ENGENHEIRO EM COMPUTACAO ',
      68: 'ENGENHEIRO MECANICO E AFINS - EXCETO ENGENHEIRO MECANICO NUCLEAR ',
      69: 'ENGENHEIRO MECANICO NUCLEAR ',
      70: 'ENGENHEIRO MECATRONICO ',
      71: 'ENGENHEIRO QUIMICO ',
      72: 'ESCRITOR',
      73: 'ESTAGIÁRIO, BOLSISTA OU TRAINEE',
      74: 'ESTUDANTE',
      75: 'FARMACÊUTICO',
      76: 'FOTÓGRAFO',
      77: 'FRENTISTA',
      78: 'GARÇOM',
      79: 'GERENTE ADMINISTRATIVO',
      80: 'GEÓLOGO',
      81: 'GUARDA-CIVIL MUNICIPAL',
      82: 'INSTALADOR DE PRODUTOS OU ACESSÓRIOS',
      83: 'INSTRUTOR DE AUTOESCOLA',
      84: 'JARDINEIRO',
      85: 'JOALHEIRO',
      86: 'JORNALISTA',
      87: 'JUIZ DE DIREITO',
      88: 'LAVADEIRO, EM GERAL',
      89: 'MANICURE',
      90: 'MAQUIADOR',
      91: 'MATEMÁTICO',
      92: 'MECÂNICO DE VEÍCULOS',
      93: 'MODELO',
      94: 'MOTOBOY',
      95: 'MOTORISTA DE CAMINHÃO / TRANSPORTADOR',
      96: 'MOTORISTA DE CARRO, FURGÃO OU VEÍCULO SIMILAR',
      97: 'MOTORISTA DE ONIBUS URBANOS, METROPOLITANOS E RODOVIÁRIOS',
      98: 'MÉDICO',
      99: 'MILITAR EM GERAL',
      100: 'PADEIRO',
      101: 'PARAMÉDICO',
      102: 'PEDREIRO',
      103: 'PILOTO DE AVIÃO',
      104: 'POLICIA CIVIL - AGENTE DE SEGURANÇA PENITENCIÁRIA',
      105: 'POLICIAL CIVIL, EXCETO AGENTE PENITENCIÁRIO',
      106: 'POLICIAL FEDERAL, FERROVIÁRIO E RODOVIÁRIO',
      107: 'POLICIAL MILITAR',
      108: 'PORTEIRO',
      109: 'PRODUTOR AGRÍCOLA',
      110: 'PROFESSOR',
      111: 'PROGRAMADOR',
      112: 'PSICÓLOGO',
      113: 'PUBLICITÁRIO',
      114: 'QUÍMICO',
      115: 'REPÓRTER',
      116: 'TATUADOR',
      117: 'TELEFONISTA',
      118: 'VENDEDOR / VENDEDOR AMBULANTE',
      119: 'VEREADOR',
      120: 'VETERINÁRIO',
      121: 'VIGILANTE OU SEGURANÇA',
      122: "ZELADOR",
      123: "AUXILIAR GERAL",
      124: "AUXILIAR DE LIMPEZA",
      125: "CASEIRO",
      126: "ANALISTA DE AUTOMAÇÃO",
      127: "FUNCIONÁRIO PÚBLICO",
      128: "PINTOR",
      129: "ADMINISTRADOR",
      130: "TÉCNICO EM INFORMÁTICA",
      131: "FISIOTERAPEUTA",
      132: "FONOAUDIÓLOGA",
      133: "TERAPEUTA OCUPACIONAL",
      134: "ADMINISTRADOR DE EMPRESAS",
      135: "MINISTRO DE CULTO RELIGIOSO",
    };

  }

  public static get profissoesAutoTxt(): any {

    return {
      21: 'Administrador',
      1: 'Advogado',
      38: 'Agricultor',
      22: 'Analista de Sistemas',
      2: 'Aposentado',
      3: 'Arquiteto',
      23: 'Atuario',
      4: 'Bombeiro',
      24: 'Caminhoneiro',
      39: 'Comerciante',
      25: 'Corretor de Imóveis',
      26: 'Corretor de Seguros',
      27: 'Dentista',
      28: 'Desempregado',
      5: 'Detetive',
      29: 'Diretor de Empresa',
      43: 'Do Lar',
      37: 'Enfermeiro(a)',
      6: 'Engenheiro',
      7: 'Entregador',
      8: 'Estudante',
      33: 'Fiscal',
      42: 'Funcionario Publico',
      34: 'Gerente',
      10: 'Membro das forças armadas',
      35: 'Metalúrgico',
      9: 'Médico',
      40: 'Nutricionista',
      20: 'Não trabalha',
      19: 'Outras Atividades',
      41: 'Pecuarista',
      30: 'Pensionista',
      11: 'Personal Trainer',
      12: 'Policial',
      32: 'Produtor Rural',
      13: 'Professor',
      14: 'Promotor Vendas',
      15: 'Proprietário de Empresas/Negócios',
      16: 'Químico',
      17: 'Representante Comercial',
      18: 'Servidor Público',
      31: 'Taxista',
      36: 'Técnico em Eletrônica'
    };

  }

  public static get estadoCivilTxt(): any {

    return {
      1: 'Solteiro(a)',
      2: 'Casado(a)',
      3: 'Separado(a)',
      4: 'Divorciado(a)',
      5: 'Viuvo(a)',
      6: 'União Estável'
    };

  }

  public static get tipoResidenciaTxt(): any {

    return {
      1: 'CASA / SOBRADO',
      2: 'CASA EM CONDOMÍNIO',
      3: 'APARTAMENTO / FLAT',
      4: 'CHÁCARA / FAZENDA / SÍTIO',
      5: 'OUTROS',
      6: 'NÃO INFORMADO'
    };

  }

  public static get combustiveisTxt(): any {

    return {
      2: 'ALCOOL',
      9: 'ALCOOL / GNV',
      3: 'DIESEL',
      5: 'ELÉTRICO',
      1: 'GASOLINA',
      7: 'GASOLINA / ALCOOL',
      8: 'GASOLINA / GNV',
      10: 'GASOL. / ALC. / GNV',
      11: 'HÍBRIDO',
      6: 'OUTROS'
    };

  }

  public static get tipoCarroceriaTxt(): any {

    return {
      1: 'Aberta',
      2: 'Baú',
      10: 'Baú Isotérmico',
      11: 'Baú Frigorífico',
      3: 'Basculante',
      4: 'Betoneira',
      5: 'Cegonha',
      6: 'Coletor de Lixo',
      7: 'Graneleira',
      8: 'Tanque',
      12: 'Furgão Lona/Slider',
      13: 'Florestal',
      9: 'Outros',
      14: 'Guincho/Plataforma',
      15: 'Nenhum'
    };

  }

  public static get periodoUsoCaminhaoTxt(): any {

    return {
      1: 'Diurno',
      2: 'Noturno',
      3: 'Ambos'
    };

  }

  public static get contratanteServicosTxt(): any {

    return {
      1: 'Uso Próprio',
      2: 'Transportadora',
      3: 'Outro tipo de empresa',
      4: 'Cooperativa',
      5: 'Motorista autônomo'
    };

  }

  public static get gerenciamentoRiscoTxt(): any {

    return {
      1: 'Cadastro de Motorista',
      2: 'Escolta Armado',
      3: 'Monitoramento',
      4: 'Rotograma',
      7: 'Nenhum'
    };

  }

  public static get dispositivoDafTxt(): any {

    return {
      0: 'Não possui',
      7: 'Alarme Sonoro',
      8: 'Chave Codificada',
      1: 'Ituran',
      2: 'Mul-T-Lock',
      3: 'Sascar',
      4: 'Tracker',
      5: 'Travas Carneiro',
      6: 'Outros',
      9: 'DAF-V'
    };
  }

  public static get isencaoFiscalTxt(): any {

    return {
      0: 'Não Possui',
      2: 'IPI',
      1: 'ICMS',
      3: 'IPI / ICMS'
    };

  }

  public static get localPernoiteTxt(): any {

    return {
      1: 'Com portão manual',
      2: 'Com portão automático',
      3: 'Em local pago (de terceiros)',
      4: 'Não tem garagem'
    };

  }

  public static get localPernoiteCaminhaoTxt(): any {

    return {
      5: 'Posto de Autoatendimento',
      6: 'Posto de Combustível',
      7: 'Estacionamento Fechado',
      8: 'Posto rodoviário',
      9: 'Não viaja'
    };

  }

  public static get sexoJovemCondutorTxt(): any {

    return {
      F: 'Feminino',
      M: 'Masculino',
      A: 'Ambos'
    };
  }

  public static get idadeJovemCondutorTxt(): any {

    return {
      17: '17 anos',
      18: '18 anos',
      19: '19 anos',
      20: '20 anos',
      21: '21 anos',
      22: '22 anos',
      23: '23 anos',
      24: '24 anos',
      25: '25 anos'

    };
  }

  public static get qtdPortasTxt(): any {

    return {
      2: '2 Portas',
      3: '3 Portas',
      4: '4 Portas',
      5: '5 Portas'
    };
  }

  public static get idaVoltaTrabalhoTxt(): any {

    return {
      0: 'Não utiliza para este fim',
      1: 'Sim, estacionamento fechado',
      2: 'Não possui estacionamento'
    };
  }

  public static get idaVoltaEstudoTxt(): any {

    return {
      0: 'Não utiliza para este fim',
      1: 'Sim, estacionamento fechado',
      2: 'Não possui estacionamento'
    };
  }

  public static get relacaoSeguradoTxt(): any {

    return {
      0: { value: 'Sem Perfil', disabled: true },
      1: { value: 'O próprio segurado', disabled: false },
      2: { value: 'Cônjuge do segurado', disabled: false },
      3: { value: 'Filho(a) do segurado', disabled: false },
      4: { value: 'Outra PF', disabled: false },
      5: { value: 'Motorista Contratado', enable: false },
      6: { value: 'Mais jovem, caso haja mais de 1 condutor principal', disabled: false },
      12: { value: 'Pai / Mãe do Segurado', disabled: false }
    };

  }

  public static get zeroKmTxt(): any {

    return {
      0: { value: true, descricao: 'Sim', disabled: false },
      1: { value: false, descricao: 'Não', disabled: false },
    };

  }

  public static get tpCoberturaTxt(): any {

    return {
      1: 'Compreensiva',
      3: 'RCF'
    };

  }

  public static get carroReservaTxt(): any {

    return {
      0: 'Não contratar',
      1: 'Básico 7 dias',
      2: 'Básico 15 dias',
      3: 'Básico 30 dias'
    };

  }

  public static get assist24hsTxt(): any {

    return {
      1: 'Básica',
      2: 'Intermediária',
      3: 'Completa'
    };

  }

  public static get assist24hsPacote(): any {
    return {
      NAO: {
        id: 1,
        name: 'Não'
      },
      BASICA: {
        id: 2,
        name: 'Básica'
      },
      INTERMEDIARIA: {
        id: 3,
        name: 'Intermediária'
      },
      COMPLETA: {
        id: 4,
        name: 'Completa'
      }
    };
  }

  public static get tpUsoTxt(): any {

    return {
      1: 'Apenas Lazer',
      2: 'Locomoção Diária',
      3: 'Prestação de serviços',
      4: 'Representação comercial',
      5: 'Transporte por aplicativos',
      12: 'Taxi',
      6: 'Outros ramos de atividade'
    };

  }

  public static get tpUsoCaminhaoTxt(): any {

    return {
      8: 'Guincho',
      7: 'Transporte de carga',
      9: 'Auto Escola',
      10: 'Coletor de Lixo',
      11: 'Socorro',
      6: 'Outros ramos de atividade'
    };

  }

  public static get kmMensalTxt(): any {

    return {
      500: 'Até 500 km',
      800: 'De 501 km até 800 km',
      1500: 'De 801 km até 1.500 km',
      1700: 'Mais de 1.500 km',
    };

  }

  public static get kmMensalCaminhaoTxt(): any {

    return {
      2500: 'Até 2.500 km',
      5000: 'De 2.501 km até 5.000 km',
      10000: 'De 5.001 km até 10.000 km ',
      11000: 'Acima de 10.000 km',
    };

  }

  public static get equipamentosCaminhaoTxt(): any {

    return {
      0: 'R$ 0,00',
      3000: 'R$ 3.000,00',
      5000: 'R$ 5.000,00',
      8000: 'R$ 8.000,00',
      10000: 'R$ 10.000,00',
      12000: 'R$ 12.000,00',
      15000: 'R$ 15.000,00',
      18000: 'R$ 18.000,00',
      20000: 'R$ 20.000,00',
      25000: 'R$ 25.000,00',
      30000: 'R$ 30.000,00',
      35000: 'R$ 35.000,00',
      40000: 'R$ 40.000,00',
      45000: 'R$ 45.000,00',
      50000: 'R$ 50.000,00',
      80000: 'R$ 80.000,00',
      100000: 'R$ 100.000,00',
    };

  }

  public static get ramos(): RamosCodes {
    return {
      AUTO: 31,
      CARRO: 31,
      MOTOCICLETA: 31,
      CAMINHAO: 31,
      VIDA: 91,
      VIDA_GLOBAL: 93,
      RESIDENCIAL: 2,
      EMPRESARIAL: 18,
      CONDOMINIO: 16,
      ACIDENTES_PESSOAIS: 81,
      VIAGEM: 69,
      BIKE: 711,
      ALUGUEL: 46
    };
  }

  public static get formaPagamento() {
    return {
      CREDITO: "CREDITO",
      PIX: "PIX",
      BOLETO: "BOLETO"
    };
  }

  public static get ramosGeral() {
    return {
      2: 'residencial',
      18: 'empresarial',
      16: 'condominio',
      31: 'auto',
      91: 'vida',
      93: 'vida_global',
      81: 'acidentes_pessoais',
      69: 'viagem',
      711: 'bike',
      46: 'aluguel'
    };
  }

  public static get mensagensSeguradoraDesabilitada() {
    return {
      imovelAtividadeProfissionalLocal: 'Não é possível calcular nesta seguradora porque não há uma atividade selecionada.',
      profissao: 'Não é possível calcular nesta seguradora porque não há uma profissão selecionada.',
    };
  }

  public static get headerRamosCotacao() {
    return [
      {
        id: '',
        titulo: 'Todos',
        icone: 'earth'
      },
      {
        id: IntegracaoConstants.ramos.AUTO,
        titulo: 'Automóvel',
        icone: 'car-hatchback'
      },
      {
        id: IntegracaoConstants.ramos.RESIDENCIAL,
        titulo: 'Residencial',
        icone: 'home'
      },
      {
        id: IntegracaoConstants.ramos.EMPRESARIAL,
        titulo: 'Empresarial',
        icone: 'factory'
      },
      {
        id: IntegracaoConstants.ramos.CONDOMINIO,
        titulo: 'Condomínio',
        icone: 'domain'
      },
      {
        id: IntegracaoConstants.ramos.VIDA,
        titulo: 'Vida',
        icone: 'cards-heart'
      },
      {
        id: IntegracaoConstants.ramos.VIDA_GLOBAL,
        titulo: 'Vida Global',
        icone: 'vida-global'
      },
      {
        id: IntegracaoConstants.ramos.ACIDENTES_PESSOAIS,
        titulo: 'Acidentes Pessoais',
        icone: 'account-injury'
      },
      {
        id: IntegracaoConstants.ramos.VIAGEM,
        titulo: "Viagem",
        icone: 'bag-suitcase'
      },
      {
        id: IntegracaoConstants.ramos.ALUGUEL,
        titulo: "Aluguel",
        icone: 'key-chain-variant'
      },
      {
        id: IntegracaoConstants.ramos.BIKE,
        titulo: "Bike",
        icone: 'bicycle'
      }
    ];
  }

  public static get tituloFormulariosRamos() {
    return {
      "auto": "Auto",
      "caminhao": "Caminhão",
      "motocicleta": "Motocicleta",
      "residencial": "Residencial",
      "condominio": "Condomínio",
      "empresarial": "Empresarial",
      "vida": "Vida",
      "vida_global": "Vida Global",
      "acidentes_pessoais": "Acidentes Pessoais",
      "viagem": "Viagem",
      "bike": "Bike",
      "aluguel": "Aluguel"
    }
  }

  public static get tipoFranquiaOptions(): any {
    return [
      {
        value: 1,
        viewValue: 'Reduzida'
      },
      {
        value: 2,
        viewValue: 'Obrigatória'

      },
      {
        value: 3,
        viewValue: 'Majorada'
      },
      {
        value: 4,
        viewValue: 'Sem Franquia'
      }
    ];
  }

  public static get carroReservaViewValue(): ViewValue[] {
    return [
      {
        value: 0,
        viewValue: 'Não contratar'
      },
      {
        value: 1,
        viewValue: 'Básico 7 dias'
      },
      {
        value: 2,
        viewValue: 'Básico 15 dias'
      },
      {
        value: 3,
        viewValue: 'Básico 30 dias'
      }
    ];
  }

  public static get vidrosViewValue(): ViewValue[] {
    return [
      {
        value: 0,
        viewValue: 'Não',
      },
      {
        value: 1,
        viewValue: 'Básico',
      },
      {
        value: 2,
        viewValue: 'Completo',
      }
    ];
  }
  
  public static get assist24hsAutoViewValue(): ViewValue[] {
    return [
      {
        value: 0,
        viewValue: 'Não',
      },
      {
        value: 4,
        viewValue: 'Básica',
      },
      {
        value: 2,
        viewValue: 'Intermediária',
      },
      {
        value: 1,
        viewValue: 'Completa',
      }
    ];
  }

  public static get guinchoKmViewValue(): ViewValue[] {
    return [
      {
        value: 1,
        viewValue: '200km'
      },
      {
        value: 2,
        viewValue: '400km'
      },
      {
        value: 3,
        viewValue: '600km'
      },
      {
        value: 4,
        viewValue: '800km'
      },
      {
        value: 5,
        viewValue: '1000km'
      },
      {
        value: 6,
        viewValue: 'Ilimitado'
      },
      {
        value: 7,
        viewValue: 'Ilimitado TOP'
      }
    ];
  }

  public static get assist24hsViewValue(): ViewValue[] {
    return [
      {
        value: 1,
        viewValue: 'Não'
      },
      {
        value: 2,
        viewValue: 'Básica'
      },
      {
        value: 3,
        viewValue: 'Intermediária'
      },
      {
        value: 4,
        viewValue: 'Completa'
      }
    ];
  }

  public static get assistFuneralViewValue(): ViewValue[] {
    return [
      {
        value: 0,
        viewValue: 'Não'
      },
      {
        value: 1,
        viewValue: 'Funeral Individual'
      },
      {
        value: 2,
        viewValue: 'Funeral Familiar'

      }
    ];
  }

  public static get diariasDITViewValue(): ViewValue[] {
    return [
      { value: 0, viewValue: "Não contratado" },
      { value: 7, viewValue: "7 diárias" },
      { value: 10, viewValue: "10 diárias" },
      { value: 20, viewValue: "20 diárias" },
      { value: 30, viewValue: "30 diárias" },
      { value: 40, viewValue: "40 diárias" },
      { value: 50, viewValue: "50 diárias" },
      { value: 180, viewValue: "180 diárias" },
      { value: 365, viewValue: "365 diárias" },
    ]
  }

  public static get qtdVagasGaragemTxt(): any {
    return {
      0: 'O Prédio não possui garagens',
      1: 'Até 25 vagas',
      2: 'Até 50 vagas',
      3: 'Até 100 vagas',
      4: 'Mais de 100 vagas'
    }
  }

  public static get assistFuneralValorViewValue(): ViewValue[] {
    return [
      {
        value: 0,
        viewValue: 'R$ 0,00'
      },
      {
        value: 2000,
        viewValue: 'R$ 2.000,00'
      },
      {
        value: 3000,
        viewValue: 'R$ 3.000,00'
      },
      {
        value: 4000,
        viewValue: 'R$ 4.000,00'
      },
      {
        value: 5000,
        viewValue: 'R$ 5.000,00'
      },
      {
        value: 6000,
        viewValue: 'R$ 6.000,00'
      },
      {
        value: 7000,
        viewValue: 'R$ 7.000,00'
      },
      {
        value: 8000,
        viewValue: 'R$ 8.000,00'
      },
      {
        value: 9000,
        viewValue: 'R$ 9.000,00'
      },
      {
        value: 10000,
        viewValue: 'R$ 10.000,00'
      },
      {
        value: 15000,
        viewValue: 'R$ 15.000,00'
      }
    ];
  }

  public static get guardaVeiculoFranquiaViewValue(): ViewValue[] {
    return [
      { value: 0, viewValue: 'Não Contratada' },
      { value: 1, viewValue: 'Compreensiva' },
      { value: 2, viewValue: 'Incêndio / Roubo' },
    ]
  }

  public static get coberturasConfigCfg(): any {
    const cobs = [];

    cobs[this.ramos.AUTO] = [
      {
        value: 'tipoFranquia',
        valueTxt: 'tipoFranquia',
        label: 'Franquia',
        optionType: 'viewValue',
        arrayOptions: this.tipoFranquiaOptions
      },
      {
        value: 'isDanosMateriais',
        valueTxt: 'isDanosMateriaisTxtRS',
        label: 'Danos Materiais',
        optionType: 'intervalViewValue1'
      },
      {
        value: 'isDanosCorporais',
        valueTxt: 'isDanosCorporaisTxtRS',
        label: 'Danos Corporais',
        optionType: 'intervalViewValue1'
      },
      {
        value: 'isDanosMorais',
        valueTxt: 'isDanosMoraisTxtRS',
        label: 'Danos Morais',
        optionType: 'intervalViewValue2'
      },
      {
        value: 'isAppMorte',
        valueTxt: 'isAppMorteTxtRS',
        label: 'App Morte/Invalidez',
        optionType: 'intervalViewValue3'
      },
      {
        value: 'carroReserva',
        valueTxt: 'carroReserva',
        label: 'Carro Reserva',
        optionType: 'viewValue',
        arrayOptions: this.carroReservaViewValue
      },
      {
        value: 'carroReservaAr',
        valueTxt: 'carroReservaAr',
        label: 'Carro Reserva c/ Ar',
        optionType: 'boolean'
      },
      {
        value: 'despesasExtra',
        valueTxt: 'despesasExtra',
        label: 'Despesas Extra',
        optionType: 'boolean'
      },
      {
        value: 'assist24hs',
        valueTxt: 'assist24hs',
        label: 'Assistência',
        optionType: 'viewValue',
        arrayOptions: this.assist24hsAutoViewValue
      },
      {
        value: 'protecaoPneuRodas',
        valueTxt: 'protecaoPneuRodas',
        label: 'Proteção Pneu e Rodas',
        optionType: 'boolean'
      },
      {
        value: 'reparoRapido',
        valueTxt: 'reparoRapido',
        label: 'Reparo Rápido',
        optionType: 'boolean'
      },
      {
        value: 'vidros',
        valueTxt: 'vidros',
        label: 'Vidros',
        optionType: 'viewValue',
        arrayOptions: this.vidrosViewValue
      },
      {
        value: 'isBlindagemValor',
        valueTxt: 'isBlindagemValorTxtRS',
        label: 'Blindagem',
        optionType: 'intervalViewValue3'
      },
    ],
      cobs[this.ramos.VIDA] = [
        {
          value: 'assistMorte',
          valueTxt: 'morteTxtRS',
          label: 'Morte',
          optionType: 'multiplicador'
        },
        {
          value: 'isAppMorteAcidental',
          valueTxt: 'morteAcidentalTxtRS',
          label: 'Morte Acidental',
          optionType: 'multiplicador'
        },
        {
          value: 'isAppInvalidezVida',
          valueTxt: 'invalidezPermanenteTxtRS',
          label: 'Invalidez Permanente (IPA)',
          optionType: 'multiplicador'
        },
        {
          value: 'fumante',
          valueTxt: 'fumanteTxt',
          label: 'Fumante',
          optionType: 'multiplicador'
        },
        {
          value: 'isDespesasMedicasHospitalares',
          valueTxt: 'isDespesasMedicasHospitalaresTxtRS',
          label: 'Diária de Inter. Hosp. (DIH)',
          optionType: 'multiplicador'
        },
        {
          value: 'isInvalidezDoenca',
          valueTxt: 'isInvalidezDoencaTxtRS',
          label: 'Invalidez por Doença (IFPD)',
          optionType: 'multiplicador'
        },
        {
          value: 'valorDIT',
          valueTxt: 'valorDITTxtRS',
          label: 'Diária de Incap. Temp. (DIT)',
          optionType: 'multiplicador'
        },
        {
          value: 'praticaEsporteRadical',
          valueTxt: 'esportesRadicaisTxt',
          label: 'Esporte Radical',
          optionType: 'multiplicador'
        },
        {
          value: 'valorDoencasGraves',
          valueTxt: 'valorDoencasGravesTxtRS',
          label: 'Doenças Graves',
          optionType: 'multiplicador'
        },
        {
          value: 'assistFuneral',
          valueTxt: 'funeralTxt',
          label: 'Assistência Funeral',
          optionType: 'viewValue',
          arrayOptions: this.assistFuneralViewValue
        }
      ],
      cobs[this.ramos.VIDA_GLOBAL] = [
        {
          value: 'assistMorte',
          valueTxt: 'morteTxt',
          label: 'Morte',
          optionType: 'multiplicador',
        },
        {
          value: 'isAppMorteAcidental',
          valueTxt: 'morteAcidentalTxt',
          label: 'Morte Acidental',
          optionType: 'multiplicador',
        },
        {
          value: 'isAppInvalidez',
          valueTxt: 'invalidezPermanenteTxt',
          label: 'Invalidez Permanente (IPA)',
          optionType: 'multiplicador',
        },
        {
          value: 'isInvalidezDoenca',
          valueTxt: 'isInvalidezDoencaTxt',
          label: 'Invalidez Por Doença (IFPD)',
          optionType: 'multiplicador',
        },
        {
          value: 'assistFuneral',
          valueTxt: 'funeralTxt',
          label: 'Assistência Funeral',
          optionType: 'viewValue',
          arrayOptions: this.assistFuneralViewValue,
        }
      ],
      cobs[this.ramos.ACIDENTES_PESSOAIS] = [
        {
          value: 'isAppMorteAcidental',
          valueTxt: 'morteAcidentalTxtRS',
          label: 'Morte Acidental',
          optionType: 'multiplicador'
        },
        {
          value: 'isAppInvalidezVida',
          valueTxt: 'invalidezPermanenteTxtRS',
          label: 'Invalidez permanente (IPA)',
          optionType: 'multiplicador'
        },
        {
          value: 'fumante',
          valueTxt: 'fumanteTxt',
          label: 'Fumante',
          optionType: 'multiplicador'
        },
        {
          value: 'valorDIT',
          valueTxt: 'valorDITTxtRS',
          label: 'Diária de Incap. Temp. (DIT)',
          optionType: 'multiplicador'
        },
        {
          value: 'praticaEsporteRadical',
          valueTxt: 'esportesRadicaisTxt',
          label: 'Esporte Radical',
          optionType: 'multiplicador'
        },
        {
          value: 'assistFuneral',
          valueTxt: 'funeralTxt',
          label: 'Assistência Funeral',
          optionType: 'viewValue',
          arrayOptions: this.assistFuneralViewValue
        }
      ],
      cobs[this.ramos.RESIDENCIAL] = [
        {
          value: 'porResidDanosEletricos',
          valueTxt: 'isDanosEletricosTxtRS',
          label: 'Danos Elétricos',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidDanosVendaval',
          valueTxt: 'isDanosVendavalTxtRS',
          label: 'Vendaval',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidDanosImpactoVeiculo',
          valueTxt: 'isDanosImpactoVeiculoTxtRS',
          label: 'Impacto veículos',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidDanosAluguel',
          valueTxt: 'isDanosAluguelTxtRS',
          label: 'Perda / pagto aluguel',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidDanosRoubo',
          valueTxt: 'isDanosRouboTxtRS',
          label: 'Roubo',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidResponsabilidadeCivil',
          valueTxt: 'responsabilidadeCivilTxtRS',
          label: 'Resp. Civil familiar',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidDanosAlagamento',
          valueTxt: 'isDanosAlagamentoTxtRS',
          label: 'Alagamento',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidDanosDesmoronamento',
          valueTxt: 'isDanosDesmoronamentoTxtRS',
          label: 'Desmoronamento',
          optionType: 'porcentagem'
        },
        {
          value: 'porResidVidros',
          valueTxt: 'isDanosVidrosTxtRS',
          label: 'Vidros',
          optionType: 'porcentagem'
        },
        {
          value: 'assist24hsResidencial',
          valueTxt: 'assist24hsTxt',
          label: 'Assistência 24 Horas',
          optionType: 'viewValue',
          arrayOptions: this.assist24hsViewValue
        },
        {
          value: 'porDanosIncendioRaioExplosao',
          valueTxt: 'isDanosIncendioRaioExplosao',
          label: 'Danos Incêndio',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosVazamentoTanquesTubulacoes',
          valueTxt: 'isDanosVazamentoTanquesTubulacoes',
          label: 'Vazamento Tanques',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosRegistrosDocumentos',
          valueTxt: 'isDanosRegistrosDocumentosTxtRS',
          label: 'Recomp. Documentos',
          optionType: 'porcentagem',
        },
        {
          value: 'porDanosEquipamentosPortateisFora',
          valueTxt: 'isDanosEquipamentosPortateisForaTxtRS',
          label: 'Danos Equip. Portáteis',
          optionType: 'porcentagem',
        },
        {
          value: 'porDanosEquipamentosEletronicos',
          valueTxt: 'isDanosEquipamentosEletronicosTxtRS',
          label: 'Danos Equip. Eletrônicos',
          optionType: 'porcentagem',
        },
        {
          value: 'isDanosMorais',
          valueTxt: 'isDanosMoraisTxtRS',
          label: 'Danos Morais',
          optionType: 'porcentagem',
        },
        {
          value: 'tumultoGreveLockOut',
          valueTxt: 'tumultoGreveLockOutTxtRS',
          label: 'Tumultos, Greves e Lock-out',
          optionType: 'porcentagem',
        },
        {
          value: 'placasSolares',
          valueTxt: 'placasSolaresTxtRS',
          label: 'Placas Solares',
          optionType: 'porcentagem',
        },
        {
          value: 'bike',
          valueTxt: 'bikeTxtRS',
          label: 'Bike',
          optionType: 'porcentagem',
        }
      ],
      cobs[this.ramos.EMPRESARIAL] = [
        {
          value: 'porDanosIncendioRaioExplosao',
          valueTxt: 'isDanosIncendioRaioExplosao',
          label: 'Incêndio / Raio / Explosão',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosEletricos',
          valueTxt: 'isDanosEletricosTxtRS',
          label: 'Danos Elétricos',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosVendaval',
          valueTxt: 'isDanosVendavalTxtRS',
          label: 'Vendaval',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosImpactoVeiculo',
          valueTxt: 'isDanosImpactoVeiculoTxtRS',
          label: 'Impacto veículos',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosAluguel',
          valueTxt: 'isDanosAluguelTxtRS',
          label: 'Perda / pagto aluguel',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosRoubo',
          valueTxt: 'isDanosRouboTxtRS',
          label: 'Roubo de Bens',
          optionType: 'porcentagem'
        },
        {
          value: 'responsabilidadeCivilOperacoes',
          valueTxt: 'responsabilidadeCivilOperacoesTxtRS',
          label: 'RC Operações',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosAlagamento',
          valueTxt: 'isDanosAlagamentoTxtRS',
          label: 'Alagamento',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosDesmoronamento',
          valueTxt: 'isDanosDesmoronamentoTxtRS',
          label: 'Desmoronamento',
          optionType: 'porcentagem'
        },
        {
          value: 'porVidrosEmpresarial',
          valueTxt: 'isDanosVidrosTxtRS',
          label: 'Vidros',
          optionType: 'porcentagem'
        },
        {
          value: 'assist24hsPacote',
          valueTxt: 'assist24hsTxt',
          label: 'Assistência',
          optionType: 'viewValue',
          arrayOptions: this.assist24hsViewValue
        },
        {
          value: 'porDanosVazamentoTanquesTubulacoes',
          valueTxt: 'isDanosVazamentoTanquesTubulacoes',
          label: 'Vazamento',
          optionType: 'porcentagem'
        },
        {
          value: 'porDanosDespesasFixas',
          valueTxt: 'isDanosDespesasFixasTxtRS',
          label: 'Danos Despesas Fixas',
          optionType: 'porcentagem'
        },
        {
          value: 'porEquipamentos',
          valueTxt: 'equipamentosTxtRS',
          label: 'Equipamentos',
          optionType: 'porcentagem'
        },
        {
          value: 'isEmpregador',
          valueTxt: 'isEmpregadorTxtRS',
          label: 'RC Empregador',
          optionType: 'multiplicador'
        },
        {
          value: 'isDanosMorais',
          valueTxt: 'isDanosMoraisTxtRS',
          label: 'Danos Morais',
          optionType: 'multiplicador'
        },
        {
          value: 'anunciosLuminosos',
          valueTxt: 'anunciosLuminososTxtRS',
          label: 'Anúncios Luminosos',
          optionType: 'multiplicador'
        },
        {
          value: 'lucroCessante',
          valueTxt: 'lucroCessanteTxtRS',
          label: 'Lucros Cessantes',
          optionType: 'multiplicador'
        },
        {
          value: 'recomposicaoDocumentos',
          valueTxt: 'recomposicaoDocumentosTxtRS',
          label: 'Recomposição de Doc.',
          optionType: 'multiplicador'
        },
        {
          value: 'rouboFurtoDeValores',
          valueTxt: 'rouboFurtoDeValoresTxtRS',
          label: 'Roubo de Valores',
          optionType: 'multiplicador'
        },
        {
          value: 'tumultoGreveLockOut',
          valueTxt: 'tumultoGreveLockOutTxtRS',
          label: 'Tumultos, Greves e Lock-out',
          optionType: 'multiplicador'
        },
        {
          value: 'isGuardaVeiculo',
          valueTxt: 'isGuardaVeiculoValorTxtRS',
          label: 'RC Garagista',
          optionType: 'multiplicador',
        },
        {
          value: 'chuveiroSprinkler',
          valueTxt: 'chuveiroSprinklerTxtRS',
          label: 'Chuveiro / Sprinkler',
          optionType: 'porcentagem'
        },
        {
          value: 'fidelidade',
          valueTxt: 'fidelidadeTxtRS',
          label: 'Fidelidade',
          optionType: 'porcentagem'
        },
        {
          value: 'placasSolares',
          valueTxt: 'placasSolaresTxtRS',
          label: 'Placas Solares',
          optionType: 'porcentagem'
        }
      ],
      cobs[this.ramos.CONDOMINIO] = [
        {
          value: 'isDanosIncendioRaioExplosao',
          valueTxt: 'isDanosIncendioRaioExplosaoTxtRS',
          label: 'Incêndio/raio/explosão',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosIncendioRaioExplosaoCond',
          valueTxt: 'isDanosIncendioRaioExplosaoCondTxtRS',
          label: 'Incêndio de Conteúdo',
          optionType: 'porcentagem'
        },
        {
          value: 'isValorCondominio',
          valueTxt: 'isValorCondominioTxtRS',
          label: 'Valor Condomínio',
          optionType: 'porcentagem'
        },
        {
          value: 'isValorSindico',
          valueTxt: 'isValorSindicoTxtRS',
          label: 'Síndico',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosVendaval',
          valueTxt: 'isDanosVendavalTxtRS',
          label: 'Vendaval',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosImpactoVeiculo',
          valueTxt: 'isDanosImpactoVeiculoTxtRS',
          label: 'Impacto Veículos',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosRoubo',
          valueTxt: 'isDanosRouboTxtRS',
          label: 'Roubo, furto qualificado',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosPortoes',
          valueTxt: 'isDanosPortoesTxtRS',
          label: 'Portões',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosMorais',
          valueTxt: 'isDanosMoraisTxtRS',
          label: 'Danos Morais',
          optionType: 'porcentagem'
        },
        {
          value: 'vidros',
          valueTxt: 'isDanosVidrosTxtRS',
          label: 'Vidros',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosDesmoronamento',
          valueTxt: 'isDanosDesmoronamentoTxtRS',
          label: 'Desmoronamento',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosAluguel',
          valueTxt: 'isDanosAluguelTxtRS',
          label: 'Perda/pagto aluguel',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosVazamentoTanquesTubulacoes',
          valueTxt: 'isDanosVazamentoTanquesTubulacoesTxtRS',
          label: 'Vazamento de tubulações',
          optionType: 'porcentagem'
        },
        {
          value: 'assist24hs',
          valueTxt: 'assist24hsTxt',
          label: 'Assistência 24hs',
          optionType: 'porcentagem'
        },
        {
          value: 'anunciosLuminosos',
          valueTxt: 'anunciosLuminososTxtRS',
          label: 'Anúncios Luminosos',
          optionType: 'porcentagem'
        },
        {
          value: 'tumultoGreveLockOut',
          valueTxt: 'tumultoGreveLockOutTxtRS',
          label: 'Tumultos, Greves e Lock-out',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosAlagamento',
          valueTxt: 'isDanosAlagamentoTxtRS',
          label: 'Alagamento',
          optionType: 'porcentagem'
        },
        {
          value: 'isDanosDespesasFixas',
          valueTxt: 'isDanosDespesasFixasTxtRS',
          label: 'Danos Despesas Fixas',
          optionType: 'porcentagem'
        },
        {
          value: 'equipamentos',
          valueTxt: 'equipamentosTxtRS',
          label: 'Equipamentos',
          optionType: 'porcentagem'
        },
        {
          value: 'isEmpregador',
          valueTxt: 'isEmpregadorTxtRS',
          label: 'RC Empregador',
          optionType: 'porcentagem'
        },
        {
          value: 'isVGFuncionarios',
          valueTxt: 'isVGFuncionariosTxtRS',
          label: 'VG Funcionários',
          optionType: 'porcentagem'
        },
        {
          value: 'garagista',
          valueTxt: 'garagistaTxtRS',
          label: 'RC Garagista (Compreensiva)',
          optionType: 'porcentagem'
        },
        {
          value: 'garagistaExclusiva',
          valueTxt: 'garagistaExclusivaTxtRS',
          label: 'RC Garagista (Exclusiva)',
          optionType: 'porcentagem'
        },
        {
          value: 'chuveiroSprinkler',
          valueTxt: 'chuveiroSprinklerTxtRS',
          label: 'Chuveiro / Sprinkler',
          optionType: 'porcentagem'
        },
        {
          value: 'placasSolares',
          valueTxt: 'placasSolaresTxtRS',
          label: 'Placas Solares',
          optionType: 'porcentagem'
        }
      ];
    cobs[this.ramos.VIAGEM] = [
      {
        value: 'morteAcidental',
        valueTxt: 'morteAcidentalTxtRS',
        label: 'Morte Acidental',
        optionType: 'porcentagem'
      },
      {
        value: 'invalidezPermanente',
        valueTxt: 'invalidezPermanenteTxtRS',
        label: 'Invalidez por Acidente',
        optionType: 'porcentagem'
      },
      {
        value: 'funeral',
        valueTxt: 'funeralTxtRS',
        label: 'Assistência Funeral',
        optionType: 'porcentagem'
      },
      {
        value: 'isDespesasMedicasHospitalares',
        valueTxt: 'isDespesasMedicasHospitalaresTxtRS',
        label: 'Despesas Médicas',
        optionType: 'porcentagem'
      },
      {
        value: 'cancelamento',
        valueTxt: 'cancelamentoTxtRS',
        label: 'Cancelamento de Viagem',
        optionType: 'porcentagem'
      },
      {
        value: 'interrupcao',
        valueTxt: 'interrupcaoTxtRS',
        label: 'Interrupção de Viagem',
        optionType: 'porcentagem'
      },
      {
        value: 'extravioBagagem',
        valueTxt: 'extravioBagagemTxtRS',
        label: 'Extravio de Bagagem',
        optionType: 'porcentagem'
      },
      {
        value: 'danosBagagem',
        valueTxt: 'danosBagagemTxtRS',
        label: 'Danos de Bagagem',
        optionType: 'porcentagem'
      },
      {
        value: 'trasladoCorpo',
        valueTxt: 'trasladoCorpoTxtRS',
        label: 'Traslado de Corpo',
        optionType: 'porcentagem'
      },
      {
        value: 'trasladoMedico',
        valueTxt: 'trasladoMedicoTxtRS',
        label: 'Traslado Médico',
        optionType: 'porcentagem'
      },
      {
        value: 'regressoSanitario',
        valueTxt: 'regressoSanitarioTxtRS',
        label: 'Regresso Sanitário',
        optionType: 'porcentagem'
      },
      {
        value: 'retornoSegurado',
        valueTxt: 'retornoSeguradoTxtRS',
        label: 'Retorno do Segurado',
        optionType: 'porcentagem'
      },
      {
        value: 'retornoFamiliar',
        valueTxt: 'retornoFamiliarTxtRS',
        label: 'Retorno da Familia',
        optionType: 'porcentagem'
      },
      {
        value: 'retornoAcompanhante',
        valueTxt: 'retornoAcompanhanteTxtRS',
        label: 'Retorno de Acompanhante',
        optionType: 'porcentagem'
      },
      {
        value: 'retornoMenores',
        valueTxt: 'retornoMenoresTxtRS',
        label: 'Retorno de menores',
        optionType: 'porcentagem'
      },
      {
        value: 'acompanhanteHospitalizacao',
        valueTxt: 'acompanhanteHospitalizacaoTxtRS',
        label: 'Acompanhante Hospitalização',
        optionType: 'porcentagem'
      },
      {
        value: 'hospedagemAcompanhante',
        valueTxt: 'hospedagemAcompanhanteTxtRS',
        label: 'Hospedagem de Acompanhante',
        optionType: 'porcentagem'
      },
      {
        value: 'acompanhamentoMenor',
        valueTxt: 'acompanhamentoMenorTxtRS',
        label: 'Acompanhamento de Menor',
        optionType: 'porcentagem'
      },
      {
        value: 'fisioterapia',
        valueTxt: 'fisioterapiaTxtRS',
        label: 'Fisioterapia',
        optionType: 'porcentagem'
      },
      {
        value: 'assistenciaFarmaceutica',
        valueTxt: 'assistenciaFarmaceuticaTxtRS',
        label: 'Despesas Farmacêuticas',
        optionType: 'porcentagem'
      },
      {
        value: 'assistenciaJuridica',
        valueTxt: 'assistenciaJuridicaTxtRS',
        label: 'Despesas Jurídicas',
        optionType: 'porcentagem'
      },
      {
        value: 'pagamentoFianca',
        valueTxt: 'pagamentoFiancaTxtRS',
        label: 'Pagamento de Fiança',
        optionType: 'porcentagem'
      },
      {
        value: 'prorrogacaoEstada',
        valueTxt: 'prorrogacaoEstadaTxtRS',
        label: 'Prorrogação de Estada',
        optionType: 'porcentagem'
      },
      {
        value: 'atrasoBagagem',
        valueTxt: 'atrasoBagagemTxtRS',
        label: 'Atraso de Bagagem',
        optionType: 'porcentagem'
      },
      {
        value: 'atrasoEmbarque',
        valueTxt: 'atrasoEmbarqueTxtRS',
        label: 'Atraso de Embarque',
        optionType: 'porcentagem'
      }
    ];
    cobs[this.ramos.BIKE] = [
      {
        value: 'isDanos',
        valueTxt: 'isDanosTxtRS',
        label: 'Danos',
        optionType: 'porcentagem'
      },
      {
        value: 'isDanosRoubo',
        valueTxt: 'isDanosRouboTxtRS',
        label: 'Roubo',
        optionType: 'porcentagem'
      },
      {
        value: 'responsabilidadeCivil',
        valueTxt: 'responsabilidadeCivilTxtRS',
        label: 'Responsabilidade civil',
        optionType: 'porcentagem'
      },
      {
        value: 'isDanosEletricos',
        valueTxt: 'isDanosEletricosTxtRS',
        label: 'Danos elétricos',
        optionType: 'porcentagem'
      },
      {
        value: 'isApIndividual',
        valueTxt: 'isApIndividualTxtRS',
        label: 'AP Individual',
        optionType: 'porcentagem'
      },
      {
        value: 'assist24hs',
        valueTxt: 'assist24hsTxt',
        label: 'Assistência',
        optionType: 'porcentagem'
      }
    ];
    cobs[this.ramos.ALUGUEL] = [
      {
        value: 'aluguel',
        valueTxt: 'aluguelTxtRS',
        label: 'Aluguel',
        optionType: 'porcentagem'
      },
      {
        value: 'iptu',
        valueTxt: 'iptuTxtRS',
        label: 'IPTU',
        optionType: 'porcentagem'
      },
      {
        value: 'agua',
        valueTxt: 'aguaTxtRS',
        label: 'Água',
        optionType: 'porcentagem'
      },
      {
        value: 'luz',
        valueTxt: 'luzTxtRS',
        label: 'Luz',
        optionType: 'porcentagem'
      },
      {
        value: 'gas',
        valueTxt: 'gasTxtRS',
        label: 'Gás',
        optionType: 'porcentagem'
      },
      {
        value: 'condominio',
        valueTxt: 'condominioTxtRS',
        label: 'Condomínio',
        optionType: 'porcentagem'
      },
      {
        value: 'danoImovel',
        valueTxt: 'danoImovelTxt',
        label: 'Danos ao Imóvel',
        optionType: 'porcentagem'
      },
      {
        value: 'pinturaInterna',
        valueTxt: 'pinturaInternaTxt',
        label: 'Pintura Interna',
        optionType: 'porcentagem'
      },
      {
        value: 'pinturaExterna',
        valueTxt: 'pinturaExternaTxt',
        label: 'Pintura Externa',
        optionType: 'porcentagem'
      },
      {
        value: 'multaContratual',
        valueTxt: 'multaContratualTxt',
        label: 'Multa Contratual',
        optionType: 'porcentagem'
      }      
    ];

    return cobs;
  }

  public static get cfgStepper(): any {
    const params = [
      {
        title: 'BÁSICO',
        id: 1
      },
      {
        title: 'NORMAL',
        id: 2
      },
      {
        title: 'DIFERENCIADO',
        id: 3
      }
    ];

    return [
      {
        id: this.ramos.AUTO,
        title: 'AUTOMÓVEL',
        icon: 'car',
        parametrizacoes: params
      }
    ];
  }

  public static get caracteristicasResidencial(): ViewValue[] {
    return [
      {
        value: 'tipoImovelTxt',
        viewValue: 'Tipo'
      },
      {
        value: 'objetoSeguradoTxt',
        viewValue: 'Objeto Segurado (Verba)'
      },
      {
        value: 'tipoConstrucaoTxt',
        viewValue: 'Construção'
      },
      {
        value: 'usoImovelTxt',
        viewValue: 'Uso'
      },
      {
        value: 'imovelPossuiAlarme',
        viewValue: 'Possui alarme'
      },
      {
        value: 'imovelPossuiVigilancia24hs',
        viewValue: 'Possui vigilância 24 horas'
      },
      {
        value: 'imovelPossuiGrades',
        viewValue: 'Possui grades',
      },
      {
        value: 'imovelPossuiCercaEletrica',
        viewValue: 'Possui cerca elétrica',
      },
      {
        value: 'imovelPossuiAlarmeMonitorado',
        viewValue: 'Possui alarme monitorado'
      },
      {
        value: 'imovelPossuiPorteiroEletronico',
        viewValue: 'Possui porteiro eletrônico'
      },
      {
        value: 'imovelPossuiCircuitoFechado',
        viewValue: 'Possui circuito fechado de TV'
      },
      {
        value: 'valorDeNovo',
        viewValue: 'Valor de novo',
      },
      {
        value: 'areaRisco',
        viewValue: 'Imóvel localizado em área de risco',
      },
      {
        value: 'seguradoProprietario',
        viewValue: 'Segurado é o proprietário do imóvel',
      },
      {
        value: 'zonaRural',
        viewValue: 'Imóvel localizado na zona rural',
      },
      {
        value: 'imovelPatrimonioHistorico',
        viewValue: 'Imóvel tombado pelo patrimônio histórico',
      },
    ];
  }

  public static get caracteristicasCondominio(): ViewValue[] {
    return [
      {
        value: 'condConstituidoLegalmente',
        viewValue: 'Cond. Constituído Legalmente'
      },
      {
        value: 'tipoCondominioTxt',
        viewValue: 'Tipo de Condomínio'
      },
      {
        value: 'anoFundacao',
        viewValue: 'Ano Fundação'
      },
      {
        value: 'qtdVagasGaragemTxt',
        viewValue: 'Vagas de Garagem'
      },
      {
        value: 'estruturaCondominioTxt',
        viewValue: 'Estrutura'
      },
      {
        value: 'areaConstruidaTxt',
        viewValue: 'Área Construída'
      },
      {
        value: 'qtdFuncionariosTxt',
        viewValue: 'Qtd. de Funcionários'
      },
      {
        value: 'qtdBlocosTxt',
        viewValue: 'Qtd. de Blocos'
      },
      {
        value: 'qtdElevadores',
        viewValue: 'Qtd. de Elevadores'
      },
      {
        value: 'pavimentosTxt',
        viewValue: 'Qtd. de Pavimentos'
      },
    ];
  }

  public static get caracteristicasVidaGlobal(): ViewValue[] {
    return [
      {
        value: 'funcionario',
        viewValue: 'Funcionários'
      },
      {
        value: 'capitalFuncionarioTxtRS',
        viewValue: 'Capital Global (Funcionários)'
      },
      {
        value: 'socio',
        viewValue: 'Sócios'
      },
      {
        value: 'capitalSocioTxtRS',
        viewValue: 'Capital Global (Sócios)'
      }
    ];
  }

  public static get caracteristicasViagem(): ViewValue[] {
    return [
      {
        value: 'motivoTxt',
        viewValue: 'Motivo da viagem'
      },
      {
        value: 'meioTransporteTxt',
        viewValue: 'Meio de transporte'
      },
      {
        value: 'tipoTxt',
        viewValue: 'Tipo da viagem'
      },
      {
        value: 'origemTxt',
        viewValue: 'Origem'
      },
      {
        value: 'destinoTxt',
        viewValue: 'Destino'
      },
      {
        value: 'totalPassageirosTxt',
        viewValue: 'Total de passageiros'
      },
      {
        value: 'esporteRadicalViagemTxt',
        viewValue: 'Esportes de aventura na viagem'
      },
      {
        value: 'motocicletaViagemTxt',
        viewValue: 'Uso de motocicleta na viagem'
      },
      {
        value: 'idadeTxt',
        viewValue: 'Idade dos passageiros'
      },
      {
        value: 'visitaEuropaTxt',
        viewValue: 'Visitará países Europeus'
      },
    ];
  }

  public static get caracteristicasBike(): ViewValue[] {
    return [
      {
        value: 'marcaTxt',
        viewValue: 'Marca'
      },
      {
        value: 'modelo',
        viewValue: 'Modelo'
      },
      {
        value: 'tipoTxt',
        viewValue: 'Tipo'
      },
      {
        value: 'dataAquisicaoTxt',
        viewValue: 'Data de aquisição'
      },
      {
        value: 'anoFabricacaoTxt',
        viewValue: 'Ano fabricação'
      },
      {
        value: 'numeroSerie',
        viewValue: 'Número de série'
      },
      {
        value: 'localCompra',
        viewValue: 'Local de compra'
      },
      {
        value: 'valorMercadoTxtRS',
        viewValue: 'Valor de mercado'
      },
      {
        value: 'estadoConservacaoTxt',
        viewValue: 'Estado de uso'
      },
      {
        value: 'notaFiscalTxt',
        viewValue: 'Nota fiscal'
      },
      {
        value: 'materialTxt',
        viewValue: 'Material do quadro'
      },
      {
        value: 'configuracaoTxt',
        viewValue: 'Configuração'
      },
      {
        value: 'modalidadeTxt',
        viewValue: 'Modalidades'
      },
      {
        value: 'usoTxt',
        viewValue: 'Utilização'
      },
      {
        value: 'terrenoTxt',
        viewValue: 'Tipo de terreno'
      },
      {
        value: 'frequenciaUsoTxt',
        viewValue: 'Freqüência de uso'
      },
      {
        value: 'assessoriaEsportivaTxt',
        viewValue: 'Assessoria esportiva'
      }
    ];
  }

  public static get caracteristicasAluguel(): ViewValue[] {
    return [
      {
        value: 'finalidadeTxt',
        viewValue: 'Finalidade'
      },
      {
        value: 'tipoTxt',
        viewValue: 'Tipo'
      },
      {
        value: 'localTxt',
        viewValue: 'Local'
      },
      {
        value: 'motivoTxt',
        viewValue: 'Motivo'
      },
      {
        value: 'dataAdmissaoTxt',
        viewValue: 'Admissão'
      },
      {
        value: 'dataFundacaoTxt',
        viewValue: 'Fundação'
      },
      {
        value: 'rendaMensalTxtRS',
        viewValue: 'Renda mensal'
      },
      {
        value: 'faturamentoMensalTxtRS',
        viewValue: 'Faturamento mensal'
      },
      {
        value: 'regimeTributarioTxt',
        viewValue: 'Regime tributário'
      },
      {
        value: 'cnaeTxt',
        viewValue: 'CNAE'
      },
      {
        value: 'nacionalidadeTxt',
        viewValue: 'Nacionalidade'
      },
      {
        value: 'ocupacaoTxt',
        viewValue: 'Ocupação'
      },
      {
        value: 'residenteTxt',
        viewValue: 'Residente'
      },
      {
        value: 'conjugeCpfTxt',
        viewValue: 'CPF do cônjuge'
      },
      {
        value: 'conjugeNome',
        viewValue: 'Cônjuge'
      },
      {
        value: 'ocupanteCpfTxt',
        viewValue: 'CPF do ocupante'
      },
      {
        value: 'ocupanteNome',
        viewValue: 'Ocupante'
      },
      {
        value: 'representanteLegalCpfTxt',
        viewValue: 'CPF do representante legal'
      },
      {
        value: 'representanteLegalNome',
        viewValue: 'Representante legal'
      }
    ];
  }

  public static get tipoCoberturaMultiTxt(): any {

    return {
      1: 'Básica',
      2: 'Normal',
      3: 'Diferenciada',
      4: 'Personalizada'
    };

  }

  public static get tipoFranquiaTxt(): any {

    return {
      1: 'Reduzida',
      2: 'Obrigatória',
      3: 'Majorada',
      4: 'Sem Franquia'
    };

  }

  public static get areaCirculacaoCaminhaoTxt(): any {

    return {
      1: 'Município e arredores até 80KM',
      2: 'Dentro do próprio estado da sede',
      3: 'América do Sul',
      4: 'Região Centro-Oeste',
      5: 'Região Sul',
      6: 'Região Sudeste',
      7: 'Mercosul',
      8: 'Região Norte',
      9: 'Região Nordeste'
    };

  }

  public static get tiposCargaCaminhaoTxt(): any {

    return {
      1: 'Agua',
      2: 'Auto Peças',
      3: 'Brinquedos',
      4: 'Canavieiro',
      5: 'Carga Viva',
      6: 'Cigarro',
      7: 'Inflamável',
      8: 'Eletrônicos',
      9: 'Alimentos',
      10: 'Frigorífico',
      11: 'Madeira',
      12: 'Mat. de construção',
      13: 'Minério',
      14: 'Armas e Munição',
      15: 'Pneu',
      16: 'Veículo',
      17: 'Confecções',
      18: 'Vidros',
      19: 'Indivisível',
      21: 'Carga Mista',
      22: 'Mudanças',
      23: 'Papel',
      24: 'Plástico',
      25: 'Móveis',
      26: 'Produtos Químicos',
      27: 'Alimentos perecívies/hortifrutigrangeiro',
      28: 'Alimentos não perecíveis',
      29: 'Bebidas',
      30: 'Mel',
      31: 'Metal',
      32: 'Calçados',
      33: 'Couro',
      34: 'Laticinios',
      35: 'Carne',
      36: 'Defensivo agrícola',
      37: 'Jardinagem',
      38: 'Lixo',
      39: 'Máquinas e implementos agrícolas',
      40: 'Grãos',
      41: 'Ração Animal',
      42: 'Supermercado',
      20: 'Outros'
    };

  }

  public static get excluirRegiaoCaminhaoTxt(): any {

    return {
      RJ: 'Rio de Janeiro',
      SP: 'São Paulo',
    };

  }

  public static get utilizacaoCaminhaoTxt(): any {

    return {
      0: 'Viaja em comboio',
      1: 'A carga é segurada',
      2: 'Possui garagem quando fora de serviço',
      3: 'O motorista tem participação na franquia',
    };

  }

  public static get tipoCupom(): TipoCupom {
    return {
      PERCENTUAL: 1,
      MONETARIO: 2
    };
  }

  public static get sinistrosAnteriorTxt(): any {

    return {
      0: 'Sem sinistros',
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
      7: '7',
      8: '8',
      9: '9',
      10: '10'
    };

  }

  public static get imovelLocalizacaoTxt(): any {

    return {
      1: 'Térreo, ou até o 1º andar de edifício',
      2: 'Em edifício a partir do 2º andar',
      3: 'Em Shopping Center',
      4: 'Em aeroporto',
      5: 'Em casa/mercado',
      6: 'Em condomínio comercial',
      7: 'Em supermercado',
      8: 'Outros'
    };
  }

  public static get rotaCorrigida(): any {

    return {
      v: 'carro',
      c: 'caminhao',
      m: 'motocicleta'
    };
  }

  public static get maskValidate(): any {

    return {
      ALTURA: '0.00',
      ANO: '0000',
      CEP: '00000-000',
      CHASSI: 'AAAAAAAAAAAAAAAAA',
      CI: '09999999999999999999999999999999999999999999999999999999999999999',
      CNPJ: '00.000.000/0000-00',
      CPF: '000.000.000-00',
      DATA: '00/00/0000',
      DOUBLE: '09',
      ELEVADORES: '09',
      FIPE: '000000-0',
      FONE: '(00) 0000-00009',
      FONE_2: '(00) 00000-0000',
      LIVRE14: '00000000000000',
      MAIL: 'A+@\.A+',
      NUMEROIMOVEL: '09999',
      PESO: '009',
      PESSOAS: '0999999999999',
      PLACA: 'SSS-0A00',
      TRIPLE: '099'
    };

  }

  public static get optionsSelectedPdfSimplificado(): any {
    return {
      SEGURADO: 1,
      CONDUTOR_PRINCIPAL: 2,
      CARACTERISTICAS: 2,
      COBERTURAS: 3,
      CALCULO_COM_ERROS: 4
    };
  }

  public static get subRamosAuto(): any {
    return [
      {
        id: 'c', value: 'caminhao'
      },
      {
        id: 'm', value: 'motocicleta'
      },
      {
        id: 'v', value: 'carro'
      },
    ];
  }

  public static get aplicacaoId(): AplicacaoIdModel {
    return {
      MULTI: 1,
      APICE: 3
    };
  }

  public static get tipoCondominioTxt(): any {
    return {
      1: 'Exclusivamente Residencial',
      2: 'Resid. - Até 15% da área ocupada por comércio',
      3: 'Residencial com escritórios/consultórios',
      4: 'Comercial',
      5: 'Misto',
      6: 'Escritórios/Consultórios',
      7: 'Edifício Garagem',
      8: 'Consultórios e escritórios com comércio',
      9: 'Flat (Exceto Hoteis e moteis)',
      10: 'Flat/Apart Hotel',
      11: 'Flat/Hotel Com comércio',
      12: 'Shopping Center',
      13: 'Escritórios',
      14: 'Consultórios'
    };
  }

  public static get vidaGrupoTxt(): any {
    return {
      0: 'Não contratada',
      1: 'Morte/Ipa',
      2: 'Morte/IPA/IEA',
      3: 'Morte/IPA/IEA/IFPD'
    };
  }

  public static get logoSeguradorasPathList(): SeguradoraPathProps[] {
    return [
      {
        id: 1,
        rotulo: 'Bradesco',
        path: 'assets/images/seguradoras/seguradora1.png'
      },
      {
        id: 2,
        rotulo: 'Yelum',
        path: 'assets/images/seguradoras/seguradora2.png'
      },
      {
        id: 3,
        rotulo: 'Mapfre',
        path: 'assets/images/seguradoras/seguradora3.png'
      },
      {
        id: 4,
        rotulo: 'HDI',
        path: 'assets/images/seguradoras/seguradora4.png'
      },
      {
        id: 5,
        rotulo: 'Allianz',
        path: 'assets/images/seguradoras/seguradora5.png'
      },
      {
        id: 6,
        rotulo: 'Sompo',
        path: 'assets/images/seguradoras/seguradora6.png'
      },
      {
        id: 7,
        rotulo: 'Zurich',
        path: 'assets/images/seguradoras/seguradora7.png'
      },
      {
        id: 8,
        rotulo: 'Porto Seguro',
        path: 'assets/images/seguradoras/seguradora8.png'
      },
      {
        id: 10,
        rotulo: 'Azul',
        path: 'assets/images/seguradoras/seguradora10.png'
      },
      {
        id: 11,
        rotulo: 'Tokio',
        path: 'assets/images/seguradoras/seguradora11.png'
      },
      {
        id: 12,
        rotulo: 'Yelum',
        path: 'assets/images/seguradoras/seguradora12.png'
      },
      {
        id: 13,
        rotulo: 'Mitsui',
        path: 'assets/images/seguradoras/seguradora13.png'
      },
      {
        id: 14,
        rotulo: 'Generali',
        path: 'assets/images/seguradoras/seguradora14.png'
      },
      {
        id: 16,
        rotulo: 'Sompo',
        path: 'assets/images/seguradoras/seguradora16.png'
      },
      {
        id: 17,
        rotulo: 'Sul América',
        path: 'assets/images/seguradoras/seguradora17.png'
      },
      {
        id: 18,
        rotulo: 'Alfa',
        path: 'assets/images/seguradoras/seguradora18.png'
      },
      {
        id: 19,
        rotulo: 'Sancor',
        path: 'assets/images/seguradoras/seguradora19.png'
      },
      {
        id: 20,
        rotulo: 'Suhai',
        path: 'assets/images/seguradoras/seguradora20.png'
      },
      {
        id: 22,
        rotulo: 'Aliro',
        path: 'assets/images/seguradoras/seguradora22.png'
      },
    ];
  }

  public static get iconsCopy() {
    return [
      {
        value: this.ramos.AUTO,
        iconSvg: 'car',
        tooltipText: 'Copiar para Auto'
      },
      {
        value: this.ramos.RESIDENCIAL,
        iconSvg: 'home_variant',
        tooltipText: 'Copiar para Residencial'
      },
      {
        value: this.ramos.VIDA,
        iconSvg: 'cards-heart',
        tooltipText: 'Copiar para Vida'
      },
      {
        value: this.ramos.VIDA_GLOBAL,
        iconSvg: 'vida-global',
        tooltipText: 'Copiar para Vida Global'
      },
      {
        value: this.ramos.ACIDENTES_PESSOAIS,
        iconSvg: 'account-injury',
        tooltipText: 'Copiar para Acidentes Pessoais'
      },
      {
        value: this.ramos.EMPRESARIAL,
        iconSvg: 'factory',
        tooltipText: 'Copiar para Empresarial',
      },
      {
        value: this.ramos.CONDOMINIO,
        iconSvg: 'city',
        tooltipText: 'Copiar para Condomínio'
      },
      {
        value: this.ramos.ALUGUEL,
        iconSvg: 'key-chain-variant',
        tooltipText: 'Copiar para Aluguel'
      },
      {
        value: this.ramos.BIKE,
        iconSvg: 'bicycle',
        tooltipText: 'Copiar para Bike'
      },
    ];
  }

  public static get camposCopiarCotacao() {
    return [
      'buscaPorSeguradora',
      'isClearDraft',
      'tipo',
      'vigenciaIni',
      'vigenciaFim',
      'tpCobertura',
      'renovacao',
      'bonusAnterior',
      'sinistrosAnterior',
      'numeroRenovacao',
      'seguradoraAnteriorId',
      'vigIniAnterior',
      'vigFimAnterior',
      'CI',
      'ramo',
      'segurado',
      'configuracoes',
      'automoveis',
    ];
  }

  public static get statusNegocios() {
    return {
      fechado: {
        titulo: 'Fechados',
        icone: 'thumb-up',
        cor: '#081342'
      },
      perdido: {
        titulo: 'Perdidos',
        icone: 'thumb-down',
        cor: '#081342'
      },
      inicio: {
        titulo: 'Iniciados',
        icone: 'play',
        cor: '#081342'
      },
      concluido: {
        titulo: 'Concluídos',
        icone: 'check-bold',
        cor: '#081342'
      }
    }
  }

  public static get opcoesNegocios() {
    return [
      {
        value: 'ramos',
        viewValue: 'Ramos'
      },
      {
        value: 'tipos',
        viewValue: 'Tipos'
      }
    ];
  }

  public static get opcoesNegociosFechados() {
    return [
      {
        value: 'a',
        viewValue: 'Todos'
      },
      {
        value: 'p',
        viewValue: 'Prêmio'
      },
      {
        value: 'c',
        viewValue: 'Comissão'
      },
      {
        value: 'q',
        viewValue: 'Quantidade'
      }
    ];
  }

  public static get statusNegociosArray() {
    return [
      {
        value: 'fechado',
        viewValue: 'Fechado'
      },
      {
        value: 'perdido',
        viewValue: 'Perdido'
      },
      {
        value: 'inicio',
        viewValue: 'Iniciado'
      },
      {
        value: 'concluido',
        viewValue: 'Fechado e Concluído'
      }
    ];
  }

  public static get doencasGravesViewValue(): ViewValue[] {
    return [
      {
        value: 0,
        viewValue: 'Não contratado'
      },
      {
        value: 1,
        viewValue: 'Até 5 Doenças'
      },
      {
        value: 2,
        viewValue: 'Até 10 Doenças'
      },
      {
        value: 3,
        viewValue: 'Até 15 Doenças'
      },
      {
        value: 4,
        viewValue: 'Até 20 Doenças'
      },
      {
        value: 5,
        viewValue: 'No min 21 Doenças'
      },
    ];
  }

  public static get esportesRadicaisViewValue(): ViewValue[] {
    return [
      { value: 0, viewValue: 'NÃO CONTRATADO' },
      { value: 1, viewValue: 'ACQUARIDE' },
      { value: 2, viewValue: 'ACROBACIA AÉREA' },
      { value: 3, viewValue: 'ALPINISMO' },
      { value: 4, viewValue: 'ASA DELTA' },
      { value: 5, viewValue: 'AUTOMOBILISMO' },
      { value: 6, viewValue: 'BALONISMO' },
      { value: 7, viewValue: 'BIATHLON E TRIATHLON' },
      { value: 8, viewValue: 'BUNGEE JUMPING' },
      { value: 9, viewValue: 'CAÇA SUBMARINA' },
      { value: 10, viewValue: 'CAÇADORES' },
      { value: 11, viewValue: 'CANOAGEM / REMO' },
      { value: 12, viewValue: 'CANYONING / CASCADING' },
      { value: 13, viewValue: 'CICLISMO' },
      { value: 14, viewValue: 'CORRIDA DE AVENTURA' },
      { value: 15, viewValue: 'ESCALADA' },
      { value: 16, viewValue: 'ESCALADA EM ROCHA' },
      { value: 17, viewValue: 'ESPELEOLOGIA' },
      { value: 18, viewValue: 'HIKKING' },
      { value: 19, viewValue: 'IATISMO / VELA' },
      { value: 20, viewValue: 'JET-SKI / SKI' },
      { value: 21, viewValue: 'JÓQUEIS' },
      { value: 22, viewValue: 'KITESURF' },
      { value: 23, viewValue: 'LUTAS MARCIAIS' },
      { value: 24, viewValue: 'MERGULHO' },
      { value: 25, viewValue: 'MONTAIN BIKE' },
      { value: 26, viewValue: 'MONTANHISMO' },
      { value: 27, viewValue: 'MOTOCICLISMO' },
      { value: 28, viewValue: 'MOTOCROSS' },
      { value: 29, viewValue: 'MOTOTRAIL' },
      { value: 30, viewValue: 'OFF-ROAD' },
      { value: 31, viewValue: 'PARAPENTE / PARAGLIDING' },
      { value: 32, viewValue: 'PÁRA-QUEDISMO' },
      { value: 33, viewValue: 'PILOTO DE PROVA (COMPETIÇÃO E MARÍTIMO)' },
      { value: 34, viewValue: 'RAFTING' },
      { value: 35, viewValue: 'RAPEL' },
      { value: 36, viewValue: 'SANDBOARD' },
      { value: 37, viewValue: 'SKATE PROFISSIONAL' },
      { value: 38, viewValue: 'SNOWBOARD' },
      { value: 39, viewValue: 'TREKKING TROPHY' },
      { value: 40, viewValue: 'ULTRALEVE' },
      { value: 41, viewValue: 'VÔO LIVRE' },
      { value: 42, viewValue: 'WAKEBOARD' },
      { value: 43, viewValue: 'WAVESKI' },
      { value: 44, viewValue: 'WINDSURF' },
      { value: 45, viewValue: 'BODYBOARD' },
      { value: 46, viewValue: 'SURF' },
      { value: 47, viewValue: 'SKYSURF' },
      { value: 48, viewValue: 'OUTROS' }
    ]
  }

  public static get valoresDITViewValue(): ViewValue[] {
    return [
      {
        "value": 0,
        "viewValue": "R$ 0,00"
      },
      {
        "value": 25,
        "viewValue": "R$ 25,00"
      },
      {
        "value": 50,
        "viewValue": "R$ 50,00"
      },
      {
        "value": 75,
        "viewValue": "R$ 75,00"
      },
      {
        "value": 100,
        "viewValue": "R$ 100,00"
      },
      {
        "value": 150,
        "viewValue": "R$ 150,00"
      },
      {
        "value": 200,
        "viewValue": "R$ 200,00"
      },
      {
        "value": 250,
        "viewValue": "R$ 250,00"
      },
      {
        "value": 300,
        "viewValue": "R$ 300,00"
      },
      {
        "value": 350,
        "viewValue": "R$ 350,00"
      },
      {
        "value": 400,
        "viewValue": "R$ 400,00"
      },
      {
        "value": 500,
        "viewValue": "R$ 500,00"
      },
      {
        "value": 600,
        "viewValue": "R$ 600,00"
      },
      {
        "value": 700,
        "viewValue": "R$ 700,00"
      },
      {
        "value": 800,
        "viewValue": "R$ 800,00"
      },
      {
        "value": 900,
        "viewValue": "R$ 900,00"
      },
      {
        "value": 1000,
        "viewValue": "R$ 1.000,00"
      },
      {
        "value": 1100,
        "viewValue": "R$ 1.100,00"
      },
      {
        "value": 1200,
        "viewValue": "R$ 1.200,00"
      },
      {
        "value": 1300,
        "viewValue": "R$ 1.300,00"
      },

    ]

  }

  public static get valoresAgencimentoViewValue(): ViewValue[] {
    return [
      { value: 0, viewValue: "0" },
      { value: 50, viewValue: "50" },
      { value: 100, viewValue: "100" },
      { value: 150, viewValue: "150" },
      { value: 200, viewValue: "200" },
      { value: 250, viewValue: "250" },
      { value: 300, viewValue: "300" },
    ]
  }

  public static get valoresFiltroPeriodo(): ViewValue[] {
    return [
      { value: 9999999, viewValue: "Todo o período" },
      { value: 7, viewValue: "Últimos 7 dias" },
      { value: 30, viewValue: "Últimos 30 dias" },
      { value: 365, viewValue: "Último ano" }
    ]
  }

  public static get corretorDigitalTypes() {
    return {
      0: "Não mapeado",
      1: "Corretor Digital",
      2: "Corretor Digital V2",
      3: "Corretor Digital Interno"
    }
  }

  public static get integracaoInfo() {
    return {
      0: "Normal / Não mapeado",
      1: "Infocap",
      2: "Iframe (antigo do Multi)",
      3: "Corp (via Wakanda)",
      4: "Sinosserra (via Wakanda)",
      5: "Robocote",
      6: "Integrações de corretoras"
    }
  }

  public static get packageType(): any {
    return {
      PRINCIPAL: 0,
      MENSAL: 1,
      DEMAIS: 2
    }
  }

  public static get nomeRamos() {
    return {
      [this.ramos.RESIDENCIAL]: 'Residencial',
      [this.ramos.EMPRESARIAL]: 'Empresarial',
      [this.ramos.CONDOMINIO]: 'Condomínio',
      [this.ramos.AUTO]: 'Automóvel',
      [this.ramos.VIDA]: 'Vida',
      [this.ramos.VIDA]: 'Vida Global',
      [this.ramos.ACIDENTES_PESSOAIS]: 'Acidentes Pessoais',
      [this.ramos.VIAGEM]: 'Viagem',
      [this.ramos.BIKE]: 'Bike',
      [this.ramos.ALUGUEL]: 'Aluguel'
    };
  }

  public static get deparaCoberturasAjustePorSeguradora(): any {
    return {
      carroReservaTxtLim: 'carroReserva',
      assist24hsTxtLim: 'guinchoKm',
      vidrosTxtLim: 'vidros',
      franquiaPadronizado: 'tipoFranquia'
    };
  }

  public static get comparaProposta(): any {
    return {
      [this.ramos.AUTO]: [{
        "indice": null,
        "campos": ["tpCobertura", "renovacao", "bonusAnterior", "sinistrosAnterior", "numeroRenovacao", "seguradoraAnteriorId", "CI"]
      }, {
        "indice": ["segurado"],
        "campos": ["nome", "tipoPessoa", "cpfCnpj", "estadoCivil", "dataNasc", "sexo", "fone1", "cep", "email", "isPCD", "fone"]
      }, {
        "indice": ['automoveis', '0', 'condutores', '0'],
        "campos": ["relacComSegurado", "tempoHabilitacao", "dataPrimHabil", "cpfCnpj", "nome", "estadoCivil", "sexo", "dataNasc", "profissao", "principal", "tpResidencia"]
      }, {
        "indice": ['automoveis', '0'],
        "campos": ["zeroKm", "dataHoraSaidaLoja", "placa", "chassi", "fipe", "anoFabricacao", "anoModelo", "descricao", "combustivel", "tipo", "portas", "passageiros", "fabricante", "tipoIsencao", "financiado", "cdAntiFurto", "cepPernoite", "cepCirculacao", "tpLocalPernoite", "kmAnual", "jovemCondutor", "jovemSexo", "jovemIdade", "tpUso", "idaVoltaEstudo", "garEstudoManha", "garEstudoNoite", "garEstudoTarde", "idaVoltaTrabalho", "garTrabManha", "garTrabNoite", "garTrabTarde", "blindado", "kitGas"]
      }],
      [this.ramos.RESIDENCIAL]: [{
        "indice": ['configuracoes'],
        "campos": ["imovelLogradouro", "imovelNumero", "imovelComplemento", "imovelBairro", "imovelCidade", "imovelUF", "imovelUso", "imovelCep", "imovelAlarme", "imovelTipoResidencia", "imovelConstrucao", "imovelOcupacao", "imovelObjetoSegurado", "imovelAtividadeProfissionalLocal", "imovelPossuiAlarme", "imovelPossuiVigilancia24hs", "isDanosIncendioRaioExplosao", "isDanosRegistrosDocumentos", "isDanosEquipamentosPortateisFora", "isDanosEquipamentosEletronicos", "isDanosEletricos", "isDanosImpactoVeiculo", "isDanosAluguel", "isDanosRoubo", "responsabilidadeCivil", "isDanosAlagamento", "isDanosDesmoronamento", "vidros", "isDanosMateriais", "despesaFixa", "assist24hs", "fidelidade", "imovelAtividade", "isDanosVendaval", "isDanosVazamentoTanquesTubulacoes", "valorDeNovo", "imovelPatrimonioHistorico"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "tipoPessoa", "cpfCnpj", "estadoCivil", "dataNasc", "sexo", "fone1", "cep", "email", "fone"]
      }, {
        "indice": null,
        "campos": ["seguradoNome", "seguradoraAnteriorId", "numeroRenovacao", "tipoSeguro", "sinistrosAnterior", "bonusAnterior"]
      }],
      [this.ramos.VIDA]: [{
        "indice": ['configuracoes'],
        "campos": ["fumante", "isAppMorte", "isAppMorteAcidental", "isAppInvalidez", "isDespesasMedicasHospitalares", "isInvalidezDoenca", "praticaEsporteRadical"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "cpfCnpj", "estadoCivil", "dataNasc", "sexo", "fone1", "cep", "email", "fone", "uf", "cidade", "bairro", "logradouro", "altura", "peso", "profissao", "rendaMensal", "fone"]
      }],
      [this.ramos.VIDA_GLOBAL]: [{
        "indice": ['configuracoes'],
        "campos": ["funcionario", "socio", "capitalFuncionario", "capitalSocio", "isAppMorteAcidental", "isAppInvalidez", "isInvalidezDoenca"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "cpfCnpj", "cep", "email", "fone", "fone1", "cnae", "atividade"]
      }],
      [this.ramos.ACIDENTES_PESSOAIS]: [{
        "indice": ['configuracoes'],
        "campos": ["fumante", "isAppMorteAcidental", "isAppInvalidez", "praticaEsporteRadical"]
      }, {
        "indice": ['configuracoes', 'DIT'],
        "campos": ["valor"]
      }, {
        "indice": ['configuracoes', 'funeral'],
        "campos": ["tipo"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "cpfCnpj", "estadoCivil", "dataNasc", "sexo", "fone1", "cep", "email", "fone", "altura", "peso", "rendaMensal", "fone"]
      }],
      [this.ramos.VIAGEM]: [{
        "indice": ['configuracoes'],
        "campos": ["motivo", "meioTransporte", "tipo", "origem", "destino", "totalPassageiros", "esporteRadicalViagem", "motocicletaViagem", "visitaEuropa", "idade"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "cpfCnpj", "dataNasc", "fone1", "email", "fone"]
      }],
      [this.ramos.EMPRESARIAL]: [{
        "indice": ['configuracoes'],
        "campos": ["imovelLogradouro", "imovelNumero", "imovelComplemento", "imovelBairro", "imovelCidade", "imovelUF", "imovelUso", "imovelCep", "imovelAlarme", "imovelTipoResidencia", "imovelConstrucao", "imovelOcupacao", "imovelObjetoSegurado", "imovelAtividadeProfissionalLocal", "imovelPossuiAlarme", "imovelPossuiVigilancia24hs", "isDanosIncendioRaioExplosao", "isDanosEletricos", "isDanosImpactoVeiculo", "isDanosAluguel", "isDanosRoubo", "responsabilidadeCivil", "isDanosAlagamento", "isDanosDesmoronamento", "vidros", "isDanosMateriais", "despesaFixa", "assist24hs", "fidelidade", "imovelAtividade", "imovelUtilizadoDeposito", "imovelDivisaTerronoBaldio", "imovelPatrimonioHistorico", "imovelTelhaEstruturaMetalica", "imovelCaixaEletronico", "imovelPossuiIsopainel", "imovelConstrucaoReforma", "valorDeNovo", "imovelPossuiExtintor", "imovelPossuiHidrante", "imovelPossuiSprinkler", "imovelPossuiDetectorFumaca", "imovelPossuiBrigadaIncendio", "imovelPossuiAlarmeMonitorado", "imovelPossuiCircuitoFechado", "imovelPossuiGrades", "imovelPossuiFechaduraTetra", "imovelPossuiSensorInfravermelho", "imovelLocalizacao", "responsabilidadeCivilOperacoes", "isDanosVazamentoTanquesTubulacoes", "isDanosEquipamentosEletronicos", "isDanosDespesasFixas", "equipamentosEstacionarios", "equipamentosMoveis", "isEmpregador", "isDanosMorais", "anunciosLuminosos", "recomposicaoDocumentos", "rouboFurtoDeValores", "tumultoGreveLockOut", "perdaLucroBruto", "isDanosContaminacaoDeterioracao"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "tipoPessoa", "cpfCnpj", "estadoCivil", "dataNasc", "sexo", "fone1", "cep", "email", "fone"]
      }],
      [this.ramos.CONDOMINIO]: [{
        "indice": ['configuracoes'],
        "campos": ["imovelLogradouro", "imovelNumero", "imovelComplemento", "imovelBairro", "imovelCidade", "imovelUF", "imovelUso", "imovelCep", "imovelAlarme", "imovelTipoResidencia", "imovelConstrucao", "imovelOcupacao", "imovelObjetoSegurado", "imovelAtividadeProfissionalLocal", "imovelPossuiAlarme", "imovelPossuiVigilancia24hs", "isDanosIncendioRaioExplosao", "isDanosEletricos", "isDanosImpactoVeiculo", "isDanosVendaval", "isDanosAluguel", "isDanosRoubo", "responsabilidadeCivil", "isDanosAlagamento", "isDanosDesmoronamento", "vidros", "isDanosMateriais", "despesaFixa", "assist24hs", "fidelidade", "condConstituidoLegalmente", "imovelAtividade", "anoFundacao", "qtdVagasGaragem", "estruturaCondominio", "qtdElevadores", "modalidade", "isDanosIncendioRaioExplosaoCond", "isValorCondominio", "isValorSindico", "isDanosPortoes", "isDanosMorais", "isDanosVazamentoTanquesTubulacoes", "tpGuardaTerceirizada", "valGuardaTerceirizada", "vidaGrupo", "valorVidaGrupo", "qtdVidaGrupo"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "tipoPessoa", "cpfCnpj", "estadoCivil", "dataNasc", "sexo", "fone1", "cep", "email"]
      }],
      [this.ramos.BIKE]: [{
        "indice": ['configuracoes'],
        "campos": ["tipo", "dataAquisicao", "anoFabricacao", "uso", "marca", "modelo", "numeroSerie", "localCompra", "valorMercado", "estadoConservacao", "notaFiscal", "material", "configuracao", "modalidade", "terreno", "frequenciaUso", "assist24hs", "isDanos", "isRoubo", "responsabilidadeCivil", "isDanosEletricos", "isApIndividual", "assessoriaEsportiva"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "cpfCnpj", "dataNasc", "sexo", "fone1", "cep", "email", "fone", "uf", "cidade", "bairro", "logradouro", "numero", "complemento"]
      }, {
        "indice": null,
        "campos": ["renovacao", "numeroRenovacao", "seguradoraAnteriorId"]
      }],
      [this.ramos.ALUGUEL]: [{
        "indice": ['configuracoes'],
        "campos": ["finalidade", "tipo", "local", "motivo", "dataAquisicao", "dataAdmissao", "nacionalidade", "ocupacao", "residente", "conjugeNome", "conjugeCpf", "assist24hs", "aluguel", "iptu", "agua", "luz", "gas", "condominio", "danoImovel", "pinturaInterna", "pinturaExterna", "multaContratual", "dataFundacao", "faturamentoMensal", "regimeTributario", "cnae", "rendaMensal"]
      }, {
        "indice": ['segurado'],
        "campos": ["nome", "cpfCnpj", "dataNasc", "fone", "fone1", "email", "cep", "cidade", "uf", "logradouro", "complemento", "bairro", "numero", "estadoCivil"]
      }, {
        "indice": null,
        "campos": ["renovacao", "banco", "numeroRenovacao", "seguradoraAnteriorId", "sinistrosAnterior", "bonusAnterior"]
      }]
    };
  }
}
